<template>
  <div>
    <v-card flat class="mb-2">
      <v-tabs v-model="activeTab" class="order-tabs" color="primary" slider-color="white" centered>
        <v-tab>Siparişler</v-tab>
        <v-tab>İade Edilenler</v-tab>
        <v-tab>Göndermen Gerekenler</v-tab>
        <v-tab>Kayıp Siparişler</v-tab>
        <v-tab>Sigorta Bedelleri</v-tab>
      </v-tabs>
    </v-card>
    <div v-show="activeTab === 0">
    <v-toolbar flat color="white">
      <v-toolbar-title
        v-for="(header, index) in $store.state.orders.hbGroup"
        :key="header && header.id != null ? `${header.id}-${index}` : index"
      >
        {{ header.id | formatHbState }}
        ({{ header.value }})
      </v-toolbar-title>


    </v-toolbar>
    <v-toolbar flat color="white">
      <v-toolbar-title>Siparişler ({{ filteredOrders.length }})</v-toolbar-title>
      <v-toolbar-title>Has Ortalama: {{ hasAverage | formatMoney }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn v-if="tenantId == 1" color="purple lighten-2" @click="openFraudModal" dark>
        <v-icon left>warning</v-icon>
        Fraud Emaili Hazırla
      </v-btn>
    </v-toolbar>

    <!-- Responsive Filter Container -->
    <v-container fluid class="pa-2">
      <v-layout wrap>
        <!-- Date Fields Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu v-model="menu1" :close-on-content-click="false" lazy transition="scale-transition" offset-y
                full-width min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="startDate" label="Baş. Tarihi" prepend-icon="event" readonly
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker @change="initialize" v-model="startDate" locale="tr-TR"
                  @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-menu v-model="menu2" :close-on-content-click="false" lazy transition="scale-transition" offset-y
                full-width min-width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field v-model="endDate" label="Bit. Tarihi" prepend-icon="event" readonly
                    v-on="on"></v-text-field>
                </template>
                <v-date-picker @change="initialize" v-model="endDate" locale="tr-TR"
                  @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-text-field v-model="search" @keyup.enter.native="initialize" append-icon="search" label="Ara"
                clearable></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md3 class="px-1">
              <v-btn color="primary" block @click="initialize" class="mt-3">
                <v-icon left>search</v-icon>
                Ara
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>

        <!-- Filter Fields Row -->
        <v-flex xs12 md12>
          <v-layout wrap>
            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <v-combobox v-model="select" :items="this.$store.getters['orders/getStateItems']" item-value="id"
                @change="initialize" item-text="value" label="Sipariş Durumları" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <v-combobox v-model="selectedInsuranceFilter" :items="this.insuranceFilters" item-value="id"
                item-text="value" label="Sigorta" @change="initialize" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <v-combobox v-model="selectedHbStateFilters" :items="this.$store.getters['orders/getHbStateItems']"
                item-value="id" item-text="value" label="Mp Durum" @change="initialize" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <v-combobox
                v-model="selectedCityFilters"
                :items="cityOptions"
                item-value="id"
                item-text="value"
                label="Şehir"
                multiple
                chips
                clearable
                @change="initialize"
              ></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1" v-if="showPaymentMethodFilter">
              <v-combobox v-model="selectedPaymentMethod" :items="paymentMethodFilters" item-value="id"
                item-text="value" label="Ödeme Yöntemi" clearable></v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md4 lg2 class="px-1">
              <div class="mt-3">
                <v-switch @change="initialize" v-model="isNotMatchComission" :label="`Eşleşmeyen Komisyon`"
                  color="primary"></v-switch>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <v-data-table v-if="!isTenant1" :headers="tableHeaders" :loading="this.$store.state.progress" :rows-per-page-items="pageItems"
      :items="filteredOrders" :pagination.sync="pagination" item-key="id" select-all v-model="selected"
      class="elevation-1">
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details
              @click.stop="toggleAll"></v-checkbox>
          </th>
          <th
            v-for="(header, index) in props.headers"
            :key="header && (header.value || header.text) ? `${header.value || header.text}-${index}` : index"
            class="px-0 text-xs-left"
            :class="[
              'column sortable',
              pagination.descending ? 'desc' : 'asc',
              header.value === pagination.sortBy ? 'active' : '',
            ]"
            @click="changeSort(header.value)"
          >
            {{ header.text }}
            <v-icon small>arrow_upward</v-icon>
          </th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr
          :active="props.selected"
          :class="{ 'purple lighten-5': props.item && props.item.items && props.item.items.some(i => i.isSentForFraud) }"
          @click="props.selected = !props.selected"
          v-for="(orderItem, key) in (props.item && props.item.items ? props.item.items : [])"
          :key="`${props.item && props.item.id != null ? props.item.id : 'order'}-${key}`"
        >
          <td>
            <v-checkbox v-if="key === 0" :input-value="props.selected" primary hide-details></v-checkbox>
          </td>
          <td class="px-0" v-if="showCustomerNotes" style="padding-left: 0; margin-left: -8px;">
            <v-btn v-if="props.item.customerNotes" icon small color="amber darken-2"
              @click.stop="openCustomerNotesDialog(props.item.customerNotes)" style="margin-left: -4px;">
              <v-icon small>speaker_notes</v-icon>
            </v-btn>
            <v-btn v-else icon small disabled style="opacity: 0.3; margin-left: -4px;">
              <v-icon small>speaker_notes</v-icon>
            </v-btn>
          </td>
          <!-- <td class="px-0">{{ props.item.id }}</td> -->
          <td class="px-1">{{ props.item.indicator }}</td>
          <td class="px-2">{{ props.item.orderDate | formatDate }}</td>
          <td class="px-2">{{ props.item.barcode }}</td>
          <td class="px-2">{{ props.item.identityNo }}</td>
          <td class="px-2">
            <span style="color: #059669; font-weight: 600;">
              {{ (props.item.orderSuccessRate && props.item.orderSuccessRate.successfulOrdersOfCustomer) || 0 }} başarılı
            </span>
            /
            <span style="color: #dc2626; font-weight: 600;">
              {{ (props.item.orderSuccessRate && props.item.orderSuccessRate.unSuccessfulOrdersOfCustomer) || 0 }} başarısız
            </span>
          </td>
          <td class="px-2">
            <span v-if="props.item.isDuplicate" style="background-color: red; color:white;font-size: 18px;">Sipariş
              Tekrarı {{
                orderItem.orderNumber
              }}</span>
            <span v-if="!props.item.isDuplicate"> {{ orderItem.orderNumber }}</span>
          </td>

          <td class="px-2">{{ props.item.shippingCity }}</td>
          <td class="px-2">{{ props.item.recipientName }}</td>
          <td class="px-2" v-if="showPhoneEmail">{{ props.item.phoneNumber }}</td>
          <td class="px-2" v-if="showPhoneEmail">{{ props.item.email }}</td>
          <td class="px-2" v-if="tenantId == 2" v-bind:class="[
            orderItem.customizedText01,
            orderItem.customizedText01.length != 26 ? 'redd' : '',
          ]">
            {{ orderItem.bankName }}-{{ orderItem.customizedText01 }}
          </td>
          <td class="px-2">{{ orderItem.hbSku }}</td>
          <td class="px-2">{{ orderItem.productName }}</td>
          <td class="px-2">
            <span v-if="props.item.state == 2">
              {{
                props.item.isSendInsurance ? "Sigortalandı" : "Sigortalanmadı"
              }} {{ props.item.insuranceTrackerMessage }}</span>
          </td>

          <td class="px-2">{{ orderItem.quantity }} -
            {{(orderItem.orderPaymentItems.find(k => k.transactionType === 4) || { quantity: 0 }).quantity}}
          </td>
          <td class="px-2">
            {{ orderItem.discountRate }} <span v-if="orderItem.discountRate != orderItem.discountRateNew"
              style="color: red;">Yeni: {{ orderItem.discountRateNew }}</span>
          </td>
          <td class="px-2">
            {{ orderItem.hasAverage }} <span
              v-if="orderItem.hasAverageNew > 0 && orderItem.hasAverage != orderItem.hasAverageNew"
              style="color: red;">Yeni:
              {{
                orderItem.hasAverageNew
              }}</span>
          </td>
          <td class="px-2">
            {{
              (orderItem.totalPrice.amount / orderItem.quantity) | formatMoney
            }}
          </td>
          <td class="px-2">{{ orderItem.totalPrice.amount | formatMoney }}</td>
          <td class="px-2">
            {{ props.item.state | formatState }}
            <div v-if="props.item.state == 3 || props.item.state == 4" class="grey--text caption">{{ props.item.updatedDate | formatDate }}</div>
          </td>
          <td class="px-2">{{ orderItem.status | formatHbState }}</td>
          <td class="px-2">{{ props.item.gibState | formatUyumStates }}</td>
          <td class="px-2" v-if="showReferenceColumn && !props.item.isReferenceNumberSend">
            <v-text-field v-model="referenceNumbers[props.item.id]" placeholder="Referans No" dense hide-details
              style="width: 120px; margin-bottom: 5px;"></v-text-field>
            <v-btn small color="orange" dark @click="sendReferenceNumber(props.item, orderItem)"
              :loading="referenceLoadingStates[props.item.id]" :disabled="!referenceNumbers[props.item.id]">
              Gönder
            </v-btn>
          </td>
          <td class="px-2" v-if="showReferenceColumn && props.item.isReferenceNumberSend">
            <span style="color: green;">✓ Gönderildi</span>
          </td>
          <td class="px-2" v-if="showPaymentActionFilter">
            <v-btn v-if="shouldShowPaymentAction(orderItem, props.item)" small color="primary" dark
              @click.stop="openPaymentActionModal(props.item)">İşlem</v-btn>
          </td>
          <td class="px-2">
            <v-btn
              v-if="key === 0"
              small
              :color="(props.item.isReadingCompleted || !props.item.requiresReading) ? 'green' : 'red'"
              dark
              @click.stop="openReadingDialog(props.item)"
            >
              <v-icon small left>{{ (props.item.isReadingCompleted || !props.item.requiresReading) ? 'check_circle' : 'qr_code_scanner' }}</v-icon>
              {{ props.item.isReadingCompleted ? 'Okuma Tamamlandı' : (!props.item.requiresReading ? 'Okuma Gerekmez' : 'Okuma Eksik') }}
            </v-btn>
          </td>
          <td class="px-2 text-center" v-if="showPaymentMethodColumn">
            <v-chip
              v-if="key === 0 && (props.item.paymentMethod !== undefined && props.item.paymentMethod !== null)"
              small
              :color="paymentMethodColor(props.item.paymentMethod)"
              :text-color="paymentMethodTextColor(props.item.paymentMethod)"
            >
              <v-icon left small>{{ paymentMethodIcon(props.item.paymentMethod) }}</v-icon>
              {{ paymentMethodLabel(props.item.paymentMethod) }}
            </v-chip>
            <span v-else-if="key === 0" class="grey--text">—</span>
          </td>
          <td class="px-2 text-center" v-if="showBlacklistColumn">
            <v-btn
              v-if="key === 0 && props.item.email"
              small
              :color="isBlackListedEmail(props.item.email) ? 'red darken-2' : 'grey lighten-1'"
              :dark="isBlackListedEmail(props.item.email)"
              :outlined="!isBlackListedEmail(props.item.email)"
              :title="isBlackListedEmail(props.item.email) ? 'Kara listeden çıkar' : 'Kara listeye ekle'"
              @click.stop="openBlacklistConfirm(props.item)">
              <v-icon small left>{{ isBlackListedEmail(props.item.email) ? 'block' : 'person_add_disabled' }}</v-icon>
              {{ isBlackListedEmail(props.item.email) ? 'Kara Listede' : 'Kara Listeye Ekle' }}
            </v-btn>
          </td>
          <td class="px-2 text-center" v-if="showCancelColumn">
            <v-btn
              v-if="key === 0"
              small
              :color="canCancelOrder(props.item) ? 'red darken-2' : 'grey lighten-2'"
              :dark="canCancelOrder(props.item)"
              :disabled="!canCancelOrder(props.item)"
              :title="cancelButtonTitle(props.item)"
              @click.stop="openCancelOrderModal(props.item)">
              <v-icon small left>cancel</v-icon>
              İptal Et
            </v-btn>
            <v-btn
              v-if="key === 0 && (props.item.state === 3 || props.item.state === 4)"
              small
              color="deep-orange darken-1"
              dark
              class="mt-1"
              title="Faturayı İptal Et"
              @click.stop="openInvoiceCancel(props.item.id, props.item.items && props.item.items[0] ? props.item.items[0].orderNumber : '')">
              <v-icon small left>receipt</v-icon>
              Fatura İptal
            </v-btn>
          </td>
          <!-- <td class="px-0">
                      <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon>
                      <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td>-->
        </tr>
      </template>

      <!-- <template v-slot:no-data>
              <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>-->
    </v-data-table>

    <div v-if="isTenant1" class="idia-column-toolbar">
      <span class="idia-column-toolbar-label">Sütunlar:</span>
      <v-btn small :color="idiaColumnPrefs.mpStatus ? 'primary' : ''" :outlined="!idiaColumnPrefs.mpStatus" class="mr-2" style="text-transform:none" @click="toggleIdiaColumn('mpStatus')">
        <v-icon small left>{{ idiaColumnPrefs.mpStatus ? 'check_box' : 'check_box_outline_blank' }}</v-icon>Mp Durum
      </v-btn>
      <v-btn small :color="idiaColumnPrefs.gibStatus ? 'primary' : ''" :outlined="!idiaColumnPrefs.gibStatus" class="mr-2" style="text-transform:none" @click="toggleIdiaColumn('gibStatus')">
        <v-icon small left>{{ idiaColumnPrefs.gibStatus ? 'check_box' : 'check_box_outline_blank' }}</v-icon>Gib Durum
      </v-btn>
      <v-btn small :color="idiaColumnPrefs.discount ? 'primary' : ''" :outlined="!idiaColumnPrefs.discount" style="text-transform:none" @click="toggleIdiaColumn('discount')">
        <v-icon small left>{{ idiaColumnPrefs.discount ? 'check_box' : 'check_box_outline_blank' }}</v-icon>İndirim
      </v-btn>
    </div>

    <v-data-table v-if="isTenant1" :headers="idiaTableHeaders" :loading="this.$store.state.progress" :rows-per-page-items="pageItems"
      :items="filteredOrders" :pagination.sync="pagination" item-key="id" select-all v-model="selected"
      class="elevation-1 idia-order-table">
      <template v-slot:headers="props">
        <tr>
          <th>
            <v-checkbox :input-value="props.all" :indeterminate="props.indeterminate" primary hide-details @click.stop="toggleAll"></v-checkbox>
          </th>
          <th v-for="(header, index) in props.headers" :key="index" class="px-2 text-xs-left">{{ header.text }}</th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr :active="props.selected"
          :class="{ 'purple lighten-5': props.item && props.item.items && props.item.items.some(i => i.isSentForFraud) }"
          @click="props.selected = !props.selected"
          v-for="(orderItem, key) in (props.item && props.item.items ? props.item.items : [])"
          :key="`${props.item && props.item.id != null ? props.item.id : 'order'}-${key}`">
          <td>
            <v-checkbox v-if="key === 0" :input-value="props.selected" primary hide-details></v-checkbox>
          </td>
          <td class="px-1" v-if="showCustomerNotes">
            <v-btn v-if="key === 0 && props.item.customerNotes" icon small color="amber darken-2" @click.stop="openCustomerNotesDialog(props.item.customerNotes)">
              <v-icon small>speaker_notes</v-icon>
            </v-btn>
          </td>
          <td class="px-2">
            <div v-if="key === 0" class="idia-group">
              <div class="idia-g-main">{{ props.item.recipientName }}</div>
              <div class="idia-g-sub" v-if="showPhoneEmail">{{ props.item.phoneNumber }}</div>
              <div class="idia-g-sub idia-g-mono" v-if="showPhoneEmail">{{ props.item.email }}</div>
              <div class="idia-g-sub" v-if="props.item.identityNo">TC: {{ props.item.identityNo }}</div>
              <div class="idia-g-sub">
                (<span style="color:#059669;font-weight:600;">{{ (props.item.orderSuccessRate && props.item.orderSuccessRate.successfulOrdersOfCustomer) || 0 }} başarılı</span>
                /
                <span style="color:#dc2626;font-weight:600;">{{ (props.item.orderSuccessRate && props.item.orderSuccessRate.unSuccessfulOrdersOfCustomer) || 0 }} başarısız</span>
                sipariş)
              </div>
            </div>
          </td>
          <td class="px-2">
            <div class="idia-group">
              <div class="idia-g-mono">{{ orderItem.orderNumber }}</div>
              <div class="idia-g-sub" v-if="key === 0">{{ props.item.orderDate | formatDate }}</div>
              <div class="idia-g-sub" v-if="key === 0">Barkod: {{ props.item.barcode }}</div>
              <div class="idia-g-sub" v-if="key === 0">Şehir: {{ props.item.shippingCity }}</div>
              <div class="idia-g-sub" v-if="key === 0">Etiket: {{ props.item.indicator }}</div>
              <span v-if="props.item.isDuplicate" class="idia-dup">Sipariş Tekrarı</span>
            </div>
          </td>
          <td class="px-2">
            <div class="idia-group">
              <div class="idia-g-main">{{ orderItem.productName }}</div>
              <div class="idia-g-sub">Kod: {{ orderItem.hbSku }}</div>
              <div class="idia-g-sub">Miktar: {{ orderItem.quantity }}</div>
              <div class="idia-g-sub">Has Ort: {{ orderItem.hasAverage }}
                <span v-if="orderItem.hasAverageNew > 0 && orderItem.hasAverage != orderItem.hasAverageNew" style="color:red;">Yeni: {{ orderItem.hasAverageNew }}</span>
              </div>
            </div>
          </td>
          <td class="px-2">
            <div class="idia-group">
              <div class="idia-g-sub">Birim: {{ (orderItem.totalPrice.amount / orderItem.quantity) | formatMoney }}</div>
              <div class="idia-g-main">{{ orderItem.totalPrice.amount | formatMoney }}</div>
            </div>
          </td>
          <td class="px-2">
            <span v-if="key === 0 && props.item.state == 2">{{ props.item.isSendInsurance ? "Sigortalandı" : "Sigortalanmadı" }} {{ props.item.insuranceTrackerMessage }}</span>
          </td>
          <td class="px-2" v-if="isIdiaContext">
            <div v-if="key === 0" class="idia-group">
              <v-chip v-if="props.item.paymentMethod !== undefined && props.item.paymentMethod !== null" small
                :color="paymentMethodColor(props.item.paymentMethod)" :text-color="paymentMethodTextColor(props.item.paymentMethod)" class="mb-1">
                <v-icon left small>{{ paymentMethodIcon(props.item.paymentMethod) }}</v-icon>{{ paymentMethodLabel(props.item.paymentMethod) }}
              </v-chip>
              <template v-if="getFirstPaycellPayment(props.item)">
                <div class="idia-g-sub">
                  <span :class="isPaycellCompleted(getFirstPaycellPayment(props.item)) ? 'idia-paycell-ok' : 'idia-paycell-fail'">
                    {{ isPaycellCompleted(getFirstPaycellPayment(props.item)) ? '✓ Ödeme gerçekleşti' : '✗ Ödeme gerçekleşmedi' }}
                  </span>
                </div>
                <div class="idia-g-sub">Tutar: {{ formatPaycellAmount(readPaycellField(getFirstPaycellPayment(props.item), 'Amount')) }}</div>
                <div class="idia-g-sub idia-g-mono">Txn: {{ readPaycellField(getFirstPaycellPayment(props.item), 'TransactionId') || '-' }}</div>
                <div class="idia-g-sub idia-g-mono">Ref: {{ readPaycellField(getFirstPaycellPayment(props.item), 'ReferenceNumber') || '-' }}</div>
                <div class="idia-g-sub">{{ formatPaycellDate(readPaycellField(getFirstPaycellPayment(props.item), 'PaidAt')) }}</div>
                <div v-if="paycellPaymentCount(props.item) > 1" class="idia-g-sub grey--text">Toplam {{ paycellPaymentCount(props.item) }} ödeme kaydı</div>
              </template>
              <span v-else class="idia-g-sub grey--text">Paycell kaydı yok</span>
            </div>
          </td>
          <td class="px-2" v-if="showReferenceColumn">
            <template v-if="key === 0 && !props.item.isReferenceNumberSend">
              <v-text-field v-model="referenceNumbers[props.item.id]" placeholder="Referans No" dense hide-details style="width: 120px; margin-bottom: 5px;"></v-text-field>
              <v-btn small color="orange" dark @click.stop="sendReferenceNumber(props.item, orderItem)" :loading="referenceLoadingStates[props.item.id]" :disabled="!referenceNumbers[props.item.id]">Gönder</v-btn>
            </template>
            <span v-else-if="key === 0" style="color: green;">✓ Gönderildi</span>
          </td>
          <td class="px-2">
            {{ props.item.state | formatState }}
            <div v-if="props.item.state == 3 || props.item.state == 4" class="grey--text caption">{{ props.item.updatedDate | formatDate }}</div>
          </td>
          <td class="px-2" v-if="idiaColumnPrefs.mpStatus">{{ orderItem.status | formatHbState }}</td>
          <td class="px-2" v-if="idiaColumnPrefs.gibStatus">{{ props.item.gibState | formatUyumStates }}</td>
          <td class="px-2" v-if="idiaColumnPrefs.discount">
            {{ orderItem.discountRate }} <span v-if="orderItem.discountRate != orderItem.discountRateNew" style="color:red;">Yeni: {{ orderItem.discountRateNew }}</span>
          </td>
          <td class="px-2" v-if="showPaymentActionFilter">
            <v-btn v-if="shouldShowPaymentAction(orderItem, props.item)" small color="primary" dark @click.stop="openPaymentActionModal(props.item)">İşlem</v-btn>
          </td>
          <td class="px-2">
            <v-btn
              v-if="key === 0"
              small
              :color="(props.item.isReadingCompleted || !props.item.requiresReading) ? 'green' : 'red'"
              dark
              @click.stop="openReadingDialog(props.item)"
            >
              <v-icon small left>{{ (props.item.isReadingCompleted || !props.item.requiresReading) ? 'check_circle' : 'qr_code_scanner' }}</v-icon>
              {{ props.item.isReadingCompleted ? 'Okuma Tamamlandı' : (!props.item.requiresReading ? 'Okuma Gerekmez' : 'Okuma Eksik') }}
            </v-btn>
          </td>
          <td class="px-2 text-center" v-if="showBlacklistColumn">
            <v-btn v-if="key === 0 && props.item.email" small
              :color="isBlackListedEmail(props.item.email) ? 'red darken-2' : 'grey lighten-1'"
              :dark="isBlackListedEmail(props.item.email)" :outlined="!isBlackListedEmail(props.item.email)"
              :title="isBlackListedEmail(props.item.email) ? 'Kara listeden çıkar' : 'Kara listeye ekle'"
              @click.stop="openBlacklistConfirm(props.item)">
              <v-icon small left>{{ isBlackListedEmail(props.item.email) ? 'block' : 'person_add_disabled' }}</v-icon>
              {{ isBlackListedEmail(props.item.email) ? 'Kara Listede' : 'Ekle' }}
            </v-btn>
          </td>
          <td class="px-2 text-center" v-if="showCancelColumn">
            <v-btn v-if="key === 0" small
              :color="canCancelOrder(props.item) ? 'red darken-2' : 'grey lighten-2'"
              :dark="canCancelOrder(props.item)" :disabled="!canCancelOrder(props.item)"
              :title="cancelButtonTitle(props.item)" @click.stop="openCancelOrderModal(props.item)">
              <v-icon small left>cancel</v-icon>İptal Et
            </v-btn>
            <v-btn v-if="key === 0 && (props.item.state === 3 || props.item.state === 4)" small color="deep-orange darken-1" dark class="mt-1"
              title="Faturayı İptal Et"
              @click.stop="openInvoiceCancel(props.item.id, props.item.items && props.item.items[0] ? props.item.items[0].orderNumber : '')">
              <v-icon small left>receipt</v-icon>Fatura İptal
            </v-btn>
          </td>
          <td class="px-2 text-center" v-if="isIdiaContext">
            <v-btn v-if="key === 0" small color="indigo darken-1" dark
              title="Müşterinin geçmiş ödemelerini göster"
              @click.stop="openPreviousPayments(props.item.packageNumber)">
              <v-icon small left>history</v-icon>Geçmiş Ödemeler
            </v-btn>
          </td>
          <td class="px-2 text-center" v-if="Number(mpId) !== 5">
            <v-btn v-if="key === 0" small :color="props.item.isLost ? 'green darken-1' : 'deep-orange darken-2'" dark
              :title="props.item.isLost ? 'Kayıp işaretini kaldır' : 'Kayıp olarak işaretle'"
              @click.stop="markLost(props.item)">
              <v-icon small left>{{ props.item.isLost ? 'undo' : 'report_problem' }}</v-icon>{{ props.item.isLost ? 'Kayıp Değil' : 'Kayıp' }}
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="prevPayDialog" max-width="980px">
      <v-card>
        <v-card-title class="indigo darken-1 white--text">
          <v-icon left color="white">history</v-icon>
          <span class="font-weight-bold">Geçmiş Ödemeler</span>
          <span class="ml-2 caption">{{ prevPayOrderNo }}</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="prevPayDialog = false"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-3">
          <div v-if="prevPayLoading" class="text-xs-center pa-4 grey--text">Yükleniyor...</div>
          <div v-else-if="prevPayError" class="pa-3 red--text">{{ prevPayError }}</div>
          <v-data-table v-else :headers="prevPayHeaders" :items="prevPayments" hide-actions class="elevation-1">
            <template v-slot:items="p">
              <td class="px-2">{{ p.item.paymentMethod }}</td>
              <td class="px-2">{{ p.item.orderNumber }}</td>
              <td class="px-2">{{ p.item.paymentStatus }}</td>
              <td class="px-2 text-xs-right">{{ formatPrevPayAmount(p.item.amount, p.item.currency) }}</td>
              <td class="px-2">{{ p.item.transactionId }}</td>
              <td class="px-2">{{ formatPrevPayDate(p.item.createdAt) }}</td>
              <td class="px-2">{{ p.item.notes }}</td>
            </template>
            <template v-slot:no-data><div class="pa-3 grey--text">Geçmiş ödeme bulunamadı.</div></template>
          </v-data-table>
        </v-card-text>
        <v-card-actions class="pa-3"><v-spacer></v-spacer><v-btn flat @click="prevPayDialog = false">Kapat</v-btn></v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout wrap justify-space-between>
      <v-flex xs12 md8>
        <v-btn color="primary" dark @click="barcodePrint" class="mb-2">Yazdır
        </v-btn>
        <v-btn color="primary" outlined dark @click="barcodePrintOld" class="mb-2">Yazdır (eski)
        </v-btn>
        <v-btn color="primary" dark @click="invoicePrint" class="mb-2">Fatura Yazdır
        </v-btn>
        <v-btn color="primary" dark @click="poolOrderAction" class="mb-2">Excel Havuza Aktar
        </v-btn>
        <v-btn color="green" dark @click="reSendInvoice" class="mb-2">Faturaları Tekrar Aktar
        </v-btn>
        <!--        <v-btn-->
        <!--            color="yellow darken-1"-->
        <!--            text-->
        <!--            @click="popupInsurance"-->
        <!--        >Sigortala-->
        <!--        </v-btn>-->
        <v-divider class="mx-2" inset vertical></v-divider>
        <input type="file" @change="uploadFile" ref="file">
        <v-btn color="yellow darken-1" dark @click="pictureUploadEvent" class="mb-2">Sigortayı Yükle</v-btn>
        <v-divider class="mx-2" inset vertical></v-divider>


      </v-flex>
      <v-flex xs12 md2>
        <v-combobox v-model="selectedAction" :items="this.$store.getters['orders/getStateItems']" item-value="id"
          item-text="value" hide-details></v-combobox>
      </v-flex>
      <v-flex xs12 md2>
        <v-btn color="primary" dark @click="saveAction" class="mb-2">Güncelle
        </v-btn>
      </v-flex>
      <v-dialog v-model="insuranceDialog" persistent max-width="1250">

        <v-card>
          <v-card-title class="headline">Sigorta</v-card-title>
          <!--          <v-card-text>Sigorta Şirketi Seçiniz</v-card-text>-->
          <v-container>
            <v-data-table :headers="headersInsurance" :items="insuranceItems" :pagination.sync="pagination"
              :rows-per-page-items="pageItems" class="elevation-1">
              <template v-slot:headers="props">
                <tr>
                  <th v-for="header in props.headers" :key="header.text" class="px-0 text-xs-center"
                    :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    @click="changeSort(header.value)">
                    {{ header.text }}
                    <v-icon small>arrow_upward</v-icon>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <td class="px-0 text-xs-center">{{ props.item.barcode }}</td>
                <td class="px-0 text-xs-center">{{ props.item.insuranceBagNumber }}</td>
                <td class="px-0 text-xs-center" v-if="props.item.isSendInsurance == 1">Sigortalandı</td>
                <td class="px-0 text-xs-center" v-else>Gönderilemedi</td>
                <td class="px-0 text-xs-center">{{ props.item.insuranceTrackerCode }}</td>
                <td class="px-0 text-xs-center">{{ props.item.insuranceTrackerMessage }}</td>
              </template>
              <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
              </template>
            </v-data-table>

            <v-layout wrap justify-space-between>

              <!--              <v-combobox-->
              <!--                  v-model="selectedInsurance"-->
              <!--                  :items="this.$store.state.insurances.insurances"-->
              <!--                  item-value="id"-->
              <!--                  item-text="name"-->
              <!--                  hide-details-->
              <!--              ></v-combobox>-->
              <!--              <v-text-field v-model="posetSeri" label="Poşet Seri" required></v-text-field>-->
              <!--              <v-text-field v-model="posetNo" :counter="max" label="Poşet No Başlangıç"-->
              <!--                            required></v-text-field>-->


            </v-layout>
          </v-container>

          <v-card-actions>
            <v-spacer></v-spacer>

            <!--            <download-excel-->
            <!--                class="v-btn warning"-->
            <!--                :data="selected"-->
            <!--                :fetch="saveInsurance"-->

            <!--                :fields="json_fields"-->
            <!--                worksheet="Sheet1"-->
            <!--                name="sigorta.xls"-->
            <!--            >Sigortala-->
            <!--            </download-excel-->
            <!--            >-->
            <v-btn color="green darken-1" text @click="insuranceDialog = false">Tamam
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="paymentActionDialog" max-width="900px" persistent>
        <v-card class="elevation-2">

          <!-- Modern Header -->
          <v-card-title class="headline white--text primary darken-1 elevation-2">
            <v-icon left color="white" size="26">verified</v-icon>
            <span class="font-weight-bold">İşlem Onayı</span>

            <v-spacer></v-spacer>

            <v-btn icon dark @click="closePaymentActionModal">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-4" v-if="paymentActionOrder">
            <v-container fluid class="pa-0">
              <v-card class="mb-4 elevation-1" outlined>
                <v-card-title class="subtitle-1 primary--text py-2">
                  <v-icon left color="primary">receipt_long</v-icon>
                  İşlem Bilgileri
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-layout wrap>
                    <v-flex xs12 sm6 class="py-2">
                      <div class="caption grey--text">Sipariş Tarihi</div>
                      <div class="body-2 font-weight-medium">
                        {{ paymentActionOrder.orderDate | formatDate }}
                      </div>
                    </v-flex>
                    <v-flex xs12 sm6 class="py-2">
                      <div class="caption grey--text">Tutar</div>
                      <div class="body-2 font-weight-bold success--text">
                        {{ paymentActionOrderTotal | formatMoney }}
                      </div>
                    </v-flex>
                    <v-flex xs12 class="py-2">
                      <div class="caption grey--text">Alıcı</div>
                      <div class="body-2 font-weight-medium">
                        {{ paymentActionOrder.recipientName }}
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>

              <v-card class="mb-4 elevation-1" outlined>
                <v-card-title class="subtitle-1 primary--text py-2">
                  <v-icon left color="primary">compare_arrows</v-icon>
                  Fiyat Karşılaştırması
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-progress-linear
                    v-if="priceComparisonLoading"
                    indeterminate
                    color="primary"
                    class="mb-3"
                  ></v-progress-linear>

                  <div v-else-if="priceComparisonData.length === 0" class="text-center grey--text">
                    Karşılaştırılacak ürün bulunamadı.
                  </div>

                  <div v-else>
                    <v-layout wrap class="mb-3">
                      <v-flex xs12 sm4 class="py-2">
                        <div class="caption grey--text">Mevcut Toplam Fiyat</div>
                        <div class="body-1 font-weight-bold">
                          {{ totalCurrentPrice | formatMoney }}
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4 class="py-2">
                        <div class="caption grey--text">Güncel Toplam Fiyat</div>
                        <div class="body-1 font-weight-bold">
                          {{ totalCurrentPriceFromDb | formatMoney }}
                        </div>
                      </v-flex>
                      <v-flex xs12 sm4 class="py-2">
                        <div class="caption grey--text">Toplam Fark</div>
                        <div
                          class="body-1 font-weight-bold"
                          :class="totalPriceDifference >= 0 ? 'success--text' : 'error--text'"
                        >
                          <span v-if="totalPriceDifference !== 0">
                            {{ totalPriceDifference >= 0 ? '+' : '' }}{{ totalPriceDifference | formatMoney }}
                          </span>
                          <span v-else>Fark yok</span>
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-data-table
                      :headers="priceComparisonHeaders"
                      :items="priceComparisonData"
                      :rows-per-page-items="[5, 10, 25]"
                      class="elevation-1"
                      dense
                    >
                      <template v-slot:items="props">
                        <td class="px-2">{{ props.item.productName }}</td>
                        <td class="px-2">{{ props.item.quantity }}</td>
                        <td class="px-2">{{ props.item.currentUnitPrice | formatMoney }}</td>
                        <td class="px-2">{{ props.item.currentTotalPrice | formatMoney }}</td>
                        <td class="px-2">{{ props.item.dbUnitPrice | formatMoney }}</td>
                        <td class="px-2">{{ props.item.dbTotalPrice | formatMoney }}</td>
                        <td
                          class="px-2"
                          :class="props.item.difference >= 0 ? 'success--text' : 'error--text'"
                        >
                          <strong v-if="props.item.difference !== 0">
                            {{ props.item.difference >= 0 ? '+' : '' }}{{ props.item.difference | formatMoney }}
                          </strong>
                          <strong v-else>Fark yok</strong>
                        </td>
                      </template>
                    </v-data-table>
                  </div>
                </v-card-text>
              </v-card>
            </v-container>
          </v-card-text>

          <!-- Action Buttons -->
          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>

            <v-btn text color="grey" @click="closePaymentActionModal">
              <v-icon left>close</v-icon>
              Vazgeç
            </v-btn>

            <v-btn color="red" dark depressed @click="handlePaymentReject">
              <v-icon left>cancel</v-icon>
              Reddet
            </v-btn>

            <v-btn color="green" dark depressed @click="handlePaymentApprove">
              <v-icon left>check_circle</v-icon>
              Onayla
            </v-btn>
          </v-card-actions>

        </v-card>
      </v-dialog>
      <v-dialog v-model="actionConfirmDialog" max-width="500">
        <v-card>
          <v-card-title class="headline">Emin misiniz?</v-card-title>
          <v-card-text>
            <div v-if="confirmActionType === 'approve'">
              Bu siparişi onaylamak istediğinize emin misiniz?
            </div>
            <div v-else>
              Bu siparişi reddetmek istediğinize emin misiniz?
            </div>
            <v-textarea
                v-if="confirmActionType === 'reject'"
                v-model="confirmCancelNote"
                label="Not (opsiyonel)"
                rows="2"
                auto-grow
                class="mt-4"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeConfirmDialog">Vazgeç</v-btn>
            <v-btn
                color="primary"
                :loading="confirmActionLoading"
                @click="confirmPaymentAction"
            >Evet</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="customerNotesDialog" max-width="500">
        <v-card>
          <v-card-title class="headline amber darken-2 white--text">
            <v-icon left color="white">speaker_notes</v-icon>
            Müşteri Notu
          </v-card-title>
          <v-card-text class="pa-4">
            <div class="body-1" style="white-space: pre-wrap; word-break: break-word; overflow-wrap: break-word;">{{ customerNotesContent }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="customerNotesDialog = false">Kapat</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Sipariş Barkod Okuma Modal -->
      <v-dialog v-model="readingDialog" max-width="640" persistent>
        <v-card class="elevation-2">
          <v-card-title class="headline white--text teal darken-1 elevation-2">
            <v-icon left color="white" size="26">qr_code_scanner</v-icon>
            <span class="font-weight-bold">Sipariş Ürün Okuma</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="closeReadingDialog">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-4">
            <v-text-field
              ref="scanInput"
              v-model="scanInput"
              label="Barkod okutun"
              prepend-inner-icon="qr_code_scanner"
              outline
              hide-details
              :disabled="readingLoading || readingComplete"
              @keyup.enter.native="onScan"
              class="mb-3"
            ></v-text-field>

            <v-card class="elevation-1" outlined>
              <v-card-title class="subtitle-1 teal--text py-2">
                <v-icon left color="teal">list</v-icon>
                Okutulacak Takılar
              </v-card-title>
              <v-divider></v-divider>
              <div v-if="!readingLines.length" class="pa-3 text-center grey--text">
                <v-icon color="green">check_circle</v-icon>
                {{ readingNote || 'Bu siparişte takı yok — okuma gerekmez. (Ziynet/Külçe kargoda düşer.)' }}
              </div>
              <v-list v-else dense>
                <v-list-tile v-for="line in readingLines" :key="line.orderItemId">
                  <v-list-tile-content>
                    <v-list-tile-title>{{ line.productName }}</v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-chip
                      small
                      :color="line.matchedQuantity >= line.quantity ? 'green' : 'grey lighten-1'"
                      text-color="white"
                    >{{ line.matchedQuantity }} / {{ line.quantity }}</v-chip>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
            </v-card>

            <!-- Bu siparişe okutulan barkodlar -->
            <v-card v-if="readBarcodes.length || scannedBarcodes.length" class="elevation-1 mt-3" outlined>
              <v-card-title class="subtitle-1 teal--text py-2">
                <v-icon left color="teal">qr_code_2</v-icon>
                Okutulan Barkodlar ({{ readBarcodes.length + scannedBarcodes.length }})
              </v-card-title>
              <v-divider></v-divider>
              <div class="pa-3">
                <v-chip
                  v-for="bc in readBarcodes"
                  :key="'r-' + bc"
                  small
                  color="green lighten-4"
                  class="ma-1"
                  title="Bu siparişe rezerve (kayıtlı)"
                >
                  <v-icon small left color="green darken-2">check</v-icon>{{ bc }}
                </v-chip>
                <v-chip
                  v-for="bc in scannedBarcodes"
                  :key="'s-' + bc"
                  small
                  color="teal lighten-4"
                  class="ma-1"
                  close
                  @input="removeScanned(bc)"
                  title="Bu oturumda okutuldu (henüz onaylanmadı) — kaldırmak için x"
                >{{ bc }}</v-chip>
              </div>
            </v-card>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn text color="grey" @click="closeReadingDialog">
              <v-icon left>close</v-icon>
              Kapat
            </v-btn>
            <v-btn
              color="green"
              dark
              depressed
              :disabled="!readingComplete || readingComplete && readingOrder && readingOrder.isReadingCompleted"
              :loading="readingConfirmLoading"
              @click="confirmReading"
            >
              <v-icon left>check_circle</v-icon>
              Onayla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- HATALI ÜRÜN uyarısı (kullanıcı Tamam'a basana dek kalır) -->
      <v-dialog v-model="readingErrorDialog" max-width="420" persistent>
        <v-card color="red darken-1" dark>
          <v-card-text class="text-center pa-5">
            <v-icon size="64" color="white">cancel</v-icon>
            <div class="headline font-weight-bold mt-3">HATALI ÜRÜN</div>
            <div class="body-1 mt-2">{{ readingErrorText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="white" outline @click="dismissReadingError">Tamam</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Zimmet onayı: takı okutanın zimmetinde değilse -->
      <v-dialog v-model="zimmetConfirmDialog" max-width="440" persistent>
        <v-card color="amber darken-2" dark>
          <v-card-text class="text-center pa-5">
            <v-icon size="56" color="white">assignment_ind</v-icon>
            <div class="headline font-weight-bold mt-3">Zimmet Onayı</div>
            <div class="body-1 mt-2">{{ zimmetConfirmText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="white" outline @click="cancelZimmetClaim">Hayır</v-btn>
            <v-btn color="white" class="amber--text text--darken-4" depressed @click="confirmZimmetClaim">Evet, zimmetime al</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- Fraud Orders Modal (Altındafırsat) -->
    <v-dialog v-model="fraudDialog" max-width="900px" persistent>
      <v-card>
        <v-card-title class="headline white--text purple lighten-2 elevation-2">
          <v-icon left color="white" size="28">warning</v-icon>
          <span class="font-weight-bold">Fraud Kontrol - Şüpheli Siparişler</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeFraudModal">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text class="pa-0">
          <v-container v-if="fraudLoading" class="text-center py-5">
            <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
            <div class="mt-3 title">Siparişler kontrol ediliyor...</div>
          </v-container>

          <v-container v-else-if="!fraudLoading && (!fraudOrders || fraudOrders.length === 0)">
            <div style="background: #e8f5e9; border-left: 4px solid #4caf50; padding: 24px; margin: 16px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; margin-bottom: 12px;">
                <v-icon large color="success" style="margin-right: 12px;">check_circle</v-icon>
                <h2 style="color: #2e7d32; margin: 0; font-size: 24px; font-weight: 500;">Şüpheli sipariş bulunamadı</h2>
              </div>
              <p style="color: #1b5e20; font-size: 16px; margin: 8px 0 8px 48px;">
                Tanımlı kurallara göre işaretlenecek sipariş yok.
              </p>
              <p style="color: #66bb6a; font-size: 14px; margin: 4px 0 0 48px;">
                Fraud kontrolü tamamlandı.
              </p>
            </div>
          </v-container>

          <v-container v-else-if="!fraudLoading && fraudOrders && fraudOrders.length > 0">
            <div style="background: #fff3e0; border-left: 4px solid #ff9800; padding: 20px; margin-bottom: 10px; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
              <div style="display: flex; align-items: center; margin-bottom: 8px;">
                <v-icon large color="warning" style="margin-right: 12px;">warning</v-icon>
                <h2 style="color: #e65100; margin: 0; font-size: 22px; font-weight: 500;">{{ fraudOrders.length }} adet şüpheli sipariş tespit edildi!</h2>
              </div>
              <p style="color: #ef6c00; font-size: 15px; margin: 4px 0 0 48px;">
                Aşağıdaki siparişler tanımlı fraud kurallarına uymaktadır.
              </p>
            </div>

            <v-data-table :headers="fraudHeaders" :items="fraudOrders" :rows-per-page-items="[10, 25, 50]" class="elevation-1">
              <template v-slot:items="props">
                <tr>
                  <td class="px-2">{{ props.item.orderNumber }}</td>
                  <td class="px-2">{{ props.item.customerName }}</td>
                  <td class="px-2 error--text font-weight-bold">{{ props.item.totalAmount | formatMoney }}</td>
                  <td class="px-2">
                    <v-chip small color="orange" text-color="white">{{ props.item.reason }}</v-chip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeFraudModal" class="px-4 white--text">
            <v-icon left>close</v-icon>
            Kapat
          </v-btn>
          <v-btn v-if="!fraudEmailPrepared && fraudOrders.length > 0" color="primary" depressed @click="prepareFraudEmail" class="px-4">
            <v-icon left>email</v-icon>
            Email'i Hazırla
          </v-btn>
          <v-btn v-if="fraudEmailPrepared" color="success" depressed @click="markFraudAsSent" class="px-4">
            <v-icon left>check</v-icon>
            Email'i Yolladım
          </v-btn>
          <v-btn v-if="fraudEmailPrepared" color="warning" text @click="fraudEmailPrepared = false" class="px-4">
            <v-icon left>close</v-icon>
            Email'i Yollamadım
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="blacklistConfirmDialog" max-width="480px" persistent>
      <v-card v-if="blacklistConfirmItem">
        <v-card-title :class="(isBlackListedEmail(blacklistConfirmItem.email) ? 'red darken-2' : 'red darken-1') + ' white--text'">
          <v-icon left color="white">{{ isBlackListedEmail(blacklistConfirmItem.email) ? 'block' : 'person_add_disabled' }}</v-icon>
          {{ isBlackListedEmail(blacklistConfirmItem.email) ? 'Kara Listeden Çıkar' : 'Kara Listeye Ekle' }}
        </v-card-title>
        <v-card-text class="pt-4">
          <p class="body-1 mb-3">
            <strong>{{ blacklistConfirmItem.email }}</strong>
            adresini kara listeden
            <strong v-if="isBlackListedEmail(blacklistConfirmItem.email)">çıkarmak</strong>
            <strong v-else>eklemek</strong>
            istediğinize emin misiniz?
          </p>
          <p class="body-2 mb-0 grey--text text--darken-1" v-if="!isBlackListedEmail(blacklistConfirmItem.email)">
            Bu kullanıcının tüm siparişleri kara listede olarak işaretlenecek.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text :disabled="blacklistConfirmLoading" @click="cancelBlacklistAction">Hayır</v-btn>
          <v-btn color="red darken-2" dark depressed :loading="blacklistConfirmLoading" @click="confirmBlacklistAction">
            <v-icon left>{{ isBlackListedEmail(blacklistConfirmItem.email) ? 'block' : 'person_add_disabled' }}</v-icon>
            Evet, {{ isBlackListedEmail(blacklistConfirmItem.email) ? 'Çıkar' : 'Ekle' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancelOrderDialog.open" max-width="560px" persistent>
      <v-card v-if="cancelOrderDialog.order">
        <v-card-title class="red darken-2 white--text">
          <v-icon left color="white">cancel</v-icon>
          <span v-if="cancelOrderDialog.step === 1">Sipariş İptal — Paket Numarası Doğrulama</span>
          <span v-else-if="cancelOrderDialog.step === 2">Sipariş İptal — Onay</span>
          <span v-else>Sipariş İptal — Sonuç</span>
        </v-card-title>

        <v-card-text class="pt-4">
          <div class="mb-3">
            <div class="caption grey--text">Sipariş Numarası</div>
            <div class="body-2 font-weight-medium">{{ cancelOrderDialog.order.orderNumber || '—' }}</div>
          </div>
          <div class="mb-3">
            <div class="caption grey--text">
              Paket Numarası
              <v-btn icon x-small @click="copyCancelPackageNumber" title="Kopyala">
                <v-icon small>content_copy</v-icon>
              </v-btn>
            </div>
            <div class="body-2 font-weight-medium" style="word-break: break-all;">
              {{ cancelOrderDialog.order.packageNumber || '—' }}
            </div>
          </div>

          <template v-if="cancelOrderDialog.step === 1">
            <v-text-field
              v-model="cancelOrderDialog.packageInput"
              label="Paket numarasını yazınız"
              :error-messages="cancelOrderDialog.error"
              autofocus
              dense
              outlined
              @keyup.enter="validateCancelPackageNumber"></v-text-field>
            <div class="caption grey--text">
              Yanlış sipariş iptalini önlemek için yukarıdaki paket numarasını birebir yazınız.
            </div>
          </template>

          <template v-else-if="cancelOrderDialog.step === 2">
            <v-alert type="warning" dense text class="mb-3">
              Bu siparişi iptal etmek istediğinize emin misiniz? Idia + Paycell iptal/iade işlemi yapılır. İşlem geri alınamaz.
            </v-alert>
            <v-textarea
              v-model="cancelOrderDialog.note"
              label="Not (zorunlu değildir)"
              placeholder="İptal nedeni veya açıklama yazabilirsiniz."
              rows="3"
              auto-grow
              dense
              outlined
              counter="500"
              :maxlength="500"></v-textarea>
          </template>

          <template v-else-if="cancelOrderDialog.step === 3">
            <v-alert v-if="cancelOrderDialog.lastResult && cancelOrderDialog.lastResult.localSuccess" type="success" dense text class="mb-3">
              Sipariş yerel olarak iptal edildi (stok geri yüklendi).
            </v-alert>

            <v-alert
              v-if="cancelOrderDialog.lastResult && !cancelOrderDialog.lastResult.idiaSuccess"
              :type="cancelOrderDialog.idiaRetryFailed ? 'error' : 'warning'"
              dense text class="mb-2">
              <div class="font-weight-bold mb-1">
                Idia'ya iptal bildirimi {{ cancelOrderDialog.idiaRetryFailed ? 'yine başarısız oldu' : 'başarısız oldu' }}.
              </div>
              <div v-if="!cancelOrderDialog.idiaRetryFailed" class="body-2">
                Aşağıdaki "Idia'ya Tekrar Gönder" butonu ile manuel tetikleyebilirsiniz.
              </div>
              <div v-else class="body-2 font-weight-medium">
                Yazılım Ekibine iletin sipariş numarası: {{ cancelOrderDialog.order.orderNumber }}
              </div>
            </v-alert>
            <v-alert
              v-if="cancelOrderDialog.lastResult && cancelOrderDialog.lastResult.idiaSuccess"
              type="success" dense text class="mb-2">
              Idia'ya iptal bildirimi başarıyla gönderildi.
            </v-alert>

            <v-alert
              v-if="cancelOrderDialog.lastResult && cancelOrderDialog.lastResult.paycellAttempted && !cancelOrderDialog.lastResult.paycellSuccess"
              type="error" dense text class="mb-0">
              <div class="font-weight-bold mb-1">
                Paycell {{ cancelOrderDialog.lastResult.paycellAction || 'iptal/iade' }} işlemi başarısız oldu.
              </div>
              <div class="body-2">
                Lütfen Paycell ekranında iptal/iade'yi gerçekleştirin veyahut yazılım ekibine haber verin.
              </div>
            </v-alert>
            <v-alert
              v-else-if="cancelOrderDialog.lastResult && cancelOrderDialog.lastResult.paycellAttempted && cancelOrderDialog.lastResult.paycellSuccess"
              type="success" dense text class="mb-0">
              Paycell {{ cancelOrderDialog.lastResult.paycellAction || 'iptal/iade' }} başarıyla gerçekleşti.
            </v-alert>
          </template>
        </v-card-text>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>

          <template v-if="cancelOrderDialog.step === 1">
            <v-btn text :disabled="cancelOrderDialog.busy" @click="closeCancelOrderDialog">Vazgeç</v-btn>
            <v-btn color="red darken-2" dark depressed @click="validateCancelPackageNumber">
              <v-icon left>arrow_forward</v-icon>
              Devam Et
            </v-btn>
          </template>

          <template v-else-if="cancelOrderDialog.step === 2">
            <v-btn text :disabled="cancelOrderDialog.busy" @click="cancelOrderDialog.step = 1">Geri</v-btn>
            <v-btn text :disabled="cancelOrderDialog.busy" @click="closeCancelOrderDialog">Vazgeç</v-btn>
            <v-btn color="red darken-2" dark depressed :loading="cancelOrderDialog.busy" @click="confirmOrderCancel">
              <v-icon left>check</v-icon>
              Evet, İptal Et
            </v-btn>
          </template>

          <template v-else-if="cancelOrderDialog.step === 3">
            <v-btn
              v-if="cancelOrderDialog.lastResult && !cancelOrderDialog.lastResult.idiaSuccess && !cancelOrderDialog.idiaRetryFailed"
              color="orange darken-2" dark depressed :loading="cancelOrderDialog.busy" @click="retryOrderIdiaCancel">
              <v-icon left>refresh</v-icon>
              Idia'ya Tekrar Gönder
            </v-btn>
            <v-btn color="primary" depressed :disabled="cancelOrderDialog.busy" @click="finishCancelOrderDialog">
              <v-icon left>done</v-icon>
              Kapat
            </v-btn>
          </template>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
    <div v-if="activeTab === 1">
      <returned-orders></returned-orders>
    </div>
    <div v-if="activeTab === 2">
      <pending-shipments></pending-shipments>
    </div>
    <div v-if="activeTab === 3">
      <lost-orders></lost-orders>
    </div>
    <div v-if="activeTab === 4">
      <insurance-fees></insurance-fees>
    </div>
    <order-number-confirm-dialog
      v-model="invoiceCancelDialog"
      :order-number="invoiceCancelOrder ? invoiceCancelOrder.orderNumber : ''"
      :loading="invoiceCancelLoading"
      title="E-Fatura İptali"
      header-color="error"
      header-icon="receipt_long"
      description="Bu siparişin e-faturasını iptal etmek üzeresiniz."
      confirm-question="numaralı siparişin e-faturası iptal edilecek. Bu işlem geri alınamaz."
      confirm-text="Onayla, İptal Et"
      @confirm="confirmInvoiceCancel"
    ></order-number-confirm-dialog>
    <order-number-confirm-dialog
      v-model="lostConfirmDialog"
      :order-number="lostConfirmOrder ? lostConfirmOrder.orderNumber : ''"
      :loading="lostConfirmLoading"
      title="Kayıp Olarak İşaretle"
      header-color="deep-orange"
      header-icon="report_problem"
      description="Bu siparişi KAYIP olarak işaretlemek üzeresiniz."
      confirm-question="numaralı sipariş KAYIP olarak işaretlenecek."
      confirm-text="Onayla, Kayıp İşaretle"
      @confirm="confirmMarkLost"
    ></order-number-confirm-dialog>
  </div>
</template>
<script>
import Api from "@/api/baseApi";
import inventoryApi from "@/api/inventory";
import moment from "moment/moment";
import { authenticationService } from "@/_services";
import productsApi from "@/api/products";
import mpProductsApi from "@/api/mpProducts";
import ordersApi from "@/api/orders";
import ReturnedOrders from "../returnedOrders/Index.vue";
import PendingShipments from "../pendingShipments/Index.vue";
import LostOrders from "../lostOrders/Index.vue";
import InsuranceFees from "../insuranceFees/Index.vue";
import OrderNumberConfirmDialog from "@/components/OrderNumberConfirmDialog.vue";

export default {
  components: { ReturnedOrders, PendingShipments, LostOrders, InsuranceFees, OrderNumberConfirmDialog },
  data: () => ({
    activeTab: 0,
    lostConfirmDialog: false,
    lostConfirmOrder: null,
    lostConfirmLoading: false,
    invoiceCancelDialog: false,
    invoiceCancelOrder: null,
    invoiceCancelLoading: false,
    startDate: new Date().toISOString().substr(0, 10),
    endDate: new Date().toISOString().substr(0, 10),
    menu1: false,
    modal: false,
    tenantId: 0,
    mpId: 0,
    insuranceDialog: false,
    menu2: false,
    hasAverage: null,
    isNotMatchComission: false,
    pagination: {
      sortBy: "name",
    },
    files: null,
    select: { id: -1, value: "Tümü" },
    selectedAction: { id: -1, value: "Durum Seç" },
    selectedInsurance: { id: -1, name: "Sigorta Seç" },
    selectedInsuranceFilter: { id: -1, value: "Tümü" },
    selectedHbStateFilters: { id: "", value: "Tümü" },
    selectedCityFilters: [],
    selectedPaymentMethod: null,
    search: null,
    selected: [],
    insuranceItems: [],
    orders: [],
    pageItems: [
      50,
      100,
      500,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 },
    ],
    max: 0,
    posetSeri: "AAB",
    posetNo: 2374301,
    referenceLoadingStates: {},
    referenceNumbers: {},
    paymentActionDialog: false,
    paymentActionOrder: null,
    actionConfirmDialog: false,
    confirmActionType: null,
    confirmActionLoading: false,
    confirmCancelNote: "",
    priceComparisonLoading: false,
    priceComparisonData: [],
    priceComparisonHeaders: [
      { text: "Ürün Adı", value: "productName" },
      { text: "Miktar", value: "quantity" },
      { text: "Mevcut Birim Fiyat", value: "currentUnitPrice" },
      { text: "Mevcut Toplam", value: "currentTotalPrice" },
      { text: "Güncel Birim Fiyat", value: "dbUnitPrice" },
      { text: "Güncel Toplam", value: "dbTotalPrice" },
      { text: "Fark", value: "difference" },
    ],
    cityOptions: [
      { id: "", value: "Tümü" },
      { id: "Adana", value: "Adana" },
      { id: "Adıyaman", value: "Adıyaman" },
      { id: "Afyonkarahisar", value: "Afyonkarahisar" },
      { id: "Ağrı", value: "Ağrı" },
      { id: "Aksaray", value: "Aksaray" },
      { id: "Amasya", value: "Amasya" },
      { id: "Ankara", value: "Ankara" },
      { id: "Antalya", value: "Antalya" },
      { id: "Ardahan", value: "Ardahan" },
      { id: "Artvin", value: "Artvin" },
      { id: "Aydın", value: "Aydın" },
      { id: "Balıkesir", value: "Balıkesir" },
      { id: "Bartın", value: "Bartın" },
      { id: "Batman", value: "Batman" },
      { id: "Bayburt", value: "Bayburt" },
      { id: "Bilecik", value: "Bilecik" },
      { id: "Bingöl", value: "Bingöl" },
      { id: "Bitlis", value: "Bitlis" },
      { id: "Bolu", value: "Bolu" },
      { id: "Burdur", value: "Burdur" },
      { id: "Bursa", value: "Bursa" },
      { id: "Çanakkale", value: "Çanakkale" },
      { id: "Çankırı", value: "Çankırı" },
      { id: "Çorum", value: "Çorum" },
      { id: "Denizli", value: "Denizli" },
      { id: "Diyarbakır", value: "Diyarbakır" },
      { id: "Düzce", value: "Düzce" },
      { id: "Edirne", value: "Edirne" },
      { id: "Elazığ", value: "Elazığ" },
      { id: "Erzincan", value: "Erzincan" },
      { id: "Erzurum", value: "Erzurum" },
      { id: "Eskişehir", value: "Eskişehir" },
      { id: "Gaziantep", value: "Gaziantep" },
      { id: "Giresun", value: "Giresun" },
      { id: "Gümüşhane", value: "Gümüşhane" },
      { id: "Hakkari", value: "Hakkari" },
      { id: "Hatay", value: "Hatay" },
      { id: "Iğdır", value: "Iğdır" },
      { id: "Isparta", value: "Isparta" },
      { id: "İstanbul", value: "İstanbul" },
      { id: "İzmir", value: "İzmir" },
      { id: "Kahramanmaraş", value: "Kahramanmaraş" },
      { id: "Karabük", value: "Karabük" },
      { id: "Karaman", value: "Karaman" },
      { id: "Kars", value: "Kars" },
      { id: "Kastamonu", value: "Kastamonu" },
      { id: "Kayseri", value: "Kayseri" },
      { id: "Kırıkkale", value: "Kırıkkale" },
      { id: "Kırklareli", value: "Kırklareli" },
      { id: "Kırşehir", value: "Kırşehir" },
      { id: "Kilis", value: "Kilis" },
      { id: "Kocaeli", value: "Kocaeli" },
      { id: "Konya", value: "Konya" },
      { id: "Kütahya", value: "Kütahya" },
      { id: "Malatya", value: "Malatya" },
      { id: "Manisa", value: "Manisa" },
      { id: "Mardin", value: "Mardin" },
      { id: "Mersin", value: "Mersin" },
      { id: "Muğla", value: "Muğla" },
      { id: "Muş", value: "Muş" },
      { id: "Nevşehir", value: "Nevşehir" },
      { id: "Niğde", value: "Niğde" },
      { id: "Ordu", value: "Ordu" },
      { id: "Osmaniye", value: "Osmaniye" },
      { id: "Rize", value: "Rize" },
      { id: "Sakarya", value: "Sakarya" },
      { id: "Samsun", value: "Samsun" },
      { id: "Siirt", value: "Siirt" },
      { id: "Sinop", value: "Sinop" },
      { id: "Sivas", value: "Sivas" },
      { id: "Şanlıurfa", value: "Şanlıurfa" },
      { id: "Şırnak", value: "Şırnak" },
      { id: "Tekirdağ", value: "Tekirdağ" },
      { id: "Tokat", value: "Tokat" },
      { id: "Trabzon", value: "Trabzon" },
      { id: "Tunceli", value: "Tunceli" },
      { id: "Uşak", value: "Uşak" },
      { id: "Van", value: "Van" },
      { id: "Yalova", value: "Yalova" },
      { id: "Yozgat", value: "Yozgat" },
      { id: "Zonguldak", value: "Zonguldak" },
    ],
    customerNotesDialog: false,
    customerNotesContent: "",
    // Sipariş barkod okuma
    readingDialog: false,
    readingOrder: null,
    readingLines: [],
    scannedBarcodes: [],
    scanInput: "",
    acceptedCount: 0,
    readingLoading: false,
    readingConfirmLoading: false,
    readingComplete: false,
    readingErrorDialog: false,
    readingErrorText: "",
    readingNote: "",
    claimBarcodes: [], // operatörün "zimmetime al" onayı verdiği barkodlar
    readBarcodes: [], // bu siparişe daha önce okutulup rezerve edilmiş barkodlar (backend'den)
    zimmetConfirmDialog: false,
    zimmetConfirmText: "",
    zimmetConfirmCode: "",

    insuranceFilters: [{
      id: "-1",
      value: "Durum Seç"
    },
    {
      id: 1,
      value: "Sigortalandı"
    },
    {
      id: 0,
      value: "Sigortalanmadı"
    }
    ],
    headersInsurance: [
      { text: "Barkod", value: "barcode" },
      { text: "Poşet", value: "insuranceBagNumber" },
      { text: "Sigortalandı mı?", value: "isSendInsurance" },
      { text: "Takip No", value: "insuranceTrackerCode" },
      { text: "Mesaj", value: "insuranceTrackerMessage" },
    ],
    headers: [
      // {
      //   text: "Id",
      //   align: "left",
      //   value: "id"
      // },
      { text: "Not", value: "customerNotes", sortable: false },
      { text: "Etiket", value: "indicator" },
      { text: "Sipariş Tarih", value: "orderDate" },
      { text: "Barkod", value: "barcode" },
      { text: "Tc", value: "tc" },
      { text: "Başarılı / Başarısız", value: "orderSuccessRate", sortable: false },
      { text: "Sipariş No", value: "shipmentNo" },

      { text: "Şehir", value: "shippingCity" },
      { text: "Adı", value: "recipientName" },
      { text: "Telefon", value: "phoneNumber" },
      { text: "E-posta", value: "email" },

      { text: "İban", value: "customizedText01" },
      { text: "Ürün Kodu", value: "productCode" },
      { text: "Ürün Adı", value: "productName" },
      { text: "Sigorta", value: "insuranceId" },
      { text: "Miktar", value: "amount" },
      { text: "İndirim", value: "discountRate" },
      { text: "Has Ort", value: "hasAverage" },

      { text: "Birim Fiyatı", value: "" },
      { text: "Satış Fiyatı", value: "salePrice" },
      { text: "Durum", value: "state" },
      { text: "Mp Durum", value: "status" },
      { text: "Gib Durum", value: "gibState" },
      { text: "Referans No", value: "referenceNumber", sortable: false },
      { text: "İşlem", value: "paymentAction", sortable: false },
      { text: "Okuma", value: "reading", sortable: false },
      { text: "Ödeme", value: "paymentMethodBadge", sortable: false },
      { text: "Kara Liste", value: "blacklist", sortable: false },
      { text: "İptal", value: "cancelAction", sortable: false },
      // { text: "İşlem", value: "name", sortable: false }
    ],
    json_fields: {
      Tarih: {
        field: "orderDate",
        callback: () => {
          return `${moment(String(new Date())).format("DD.MM.YYYY")}`;
        },
      },
      "Ödeme Türü": { callback: () => "Sigorta Gönderici Kargo Alıcı" },
      "Entegrasyon Türü": { callback: () => "Entegrasyonsuz" },
      "Alıcı İsmi": "companyName",
      "Alıcı Telefon": {
        field: "phoneNumber",
        callback: (value) => {
          return `${value.toString()} `;
        }
      },
      "Alıcı Kimlik No": "identityNo",
      "Alıcı Vergi Dairesi": { callback: () => "" },
      "Alıcı Vergi Numarası": { callback: () => "" },
      "Ürün Türü": { callback: () => "Altın" },
      "Şube": { callback: () => "Çobançeşme Şubesi" },
      "Poşet Numarası": "poset",
      "Teslim Alacak İsim": {
        field: "recipientName",
        callback: (value) => {
          return `${value.toString().replace(value.split(' ')[1], '')}`;
        },
      },
      "Teslim Alacak Soyisim": {
        field: "recipientName",
        callback: (value) => {
          return `${value.toString().split(' ')[1]}`;
        },
      },
      "Teslim Alacak Telefon": "phoneNumber",
      "Teslimat Adres Başlığı": { callback: () => "" },

      "Adres Metni": "shippingAddressDetail",
      "İlçe": "shippingTown",
      "İl": "shippingCity",
      "Ürün Tutarı": {
        field: "totalAmount",
        callback: (value) => {
          return `${value.toString().replace(".", ",")}`;
        }
      },
      "Gönderi Notları": { callback: () => "" },
      "Gönderi Notları 2": { callback: () => "" },
      "Satış Kanalı": { callback: () => "" },
      "Pazaryeri": { callback: () => "Hepsiburada" },
      "Kargo": { callback: () => "yk" },

    },
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
    paymentMethodFilters: [
      { id: -1, value: "Ödeme Yöntemi" },
      { id: 0, value: "Havale / EFT" },
      { id: 1, value: "Kredi Kartı" },
      { id: 4, value: "Taksitli Kredi Kartı" },
    ],
    fraudDialog: false,
    fraudOrders: [],
    fraudLoading: false,
    fraudEmailPrepared: false,
    blacklistedEmailsSet: new Set(),
    blacklistConfirmDialog: false,
    blacklistConfirmItem: null,
    blacklistConfirmLoading: false,
    cancelOrderDialog: {
      open: false,
      step: 1,
      order: null,
      packageInput: '',
      note: '',
      error: '',
      busy: false,
      lastResult: null,
      idiaRetryFailed: false,
    },
    prevPayDialog: false,
    prevPayLoading: false,
    prevPayError: '',
    prevPayOrderNo: '',
    prevPayments: [],
    prevPayHeaders: [
      { text: "Ödeme Yöntemi", value: "paymentMethod", sortable: false },
      { text: "Sipariş No", value: "orderNumber", sortable: false },
      { text: "Durum", value: "paymentStatus", sortable: false },
      { text: "Tutar", value: "amount", sortable: false, align: "right" },
      { text: "İşlem No", value: "transactionId", sortable: false },
      { text: "Tarih", value: "createdAt", sortable: false },
      { text: "Not", value: "notes", sortable: false },
    ],
    fraudHeaders: [
      { text: "Sipariş Numarası", value: "orderNumber" },
      { text: "Müşteri", value: "customerName" },
      { text: "Toplam Tutar", value: "totalAmount" },
      { text: "Sebep", value: "reason" },
    ],
    idiaColumnPrefs: {
      mpStatus: false,
      gibStatus: false,
      discount: false,
    },
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },
    selectedPaymentMethod() {
      this.selected = [];
    },
  },

  computed: {
    filteredOrders() {
      if (
        !this.showPaymentMethodFilter ||
        !this.selectedPaymentMethod ||
        this.selectedPaymentMethod.id === -1 ||
        this.selectedPaymentMethod.id === null
      ) {
        return this.orders;
      }
      return this.orders.filter((order) => {
        if (order.paymentMethod === undefined || order.paymentMethod === null) {
          return false;
        }
        return Number(order.paymentMethod) === Number(this.selectedPaymentMethod.id);
      });
    },
    showPaymentMethodFilter() {
      return Number(this.mpId) === 5;
    },
    showPaymentActionFilter() {
      return Number(this.mpId) === 5;
    },
    showCustomerNotes() {
      return Number(this.mpId) === 5;
    },
    showPhoneEmail() {
      return Number(this.mpId) === 5;
    },
    showReferenceColumn() {
      return Number(this.tenantId) === 2 && Number(this.mpId) === 4;
    },
    showBlacklistColumn() {
      return Number(this.tenantId) === 1 && Number(this.mpId) === 5;
    },
    showPaymentMethodColumn() {
      return Number(this.tenantId) === 1 && Number(this.mpId) === 5;
    },
    showCancelColumn() {
      return Number(this.tenantId) === 1 && Number(this.mpId) === 5;
    },
    isIdiaContext() {
      return Number(this.tenantId) === 1 && Number(this.mpId) === 5;
    },
    isTenant1() {
      return Number(this.tenantId) === 1;
    },
    idiaTableHeaders() {
      const h = [];
      if (this.showCustomerNotes) h.push({ text: "Not", value: "customerNotes", sortable: false });
      h.push({ text: "Alıcı", value: "recipientName", sortable: false });
      h.push({ text: "Sipariş", value: "shipmentNo", sortable: false });
      h.push({ text: "Ürün", value: "productName", sortable: false });
      h.push({ text: "Fiyat", value: "salePrice", sortable: false });
      h.push({ text: "Sigorta", value: "insuranceId", sortable: false });
      if (this.isIdiaContext) h.push({ text: "Ödeme", value: "paymentGroup", sortable: false });
      if (this.showReferenceColumn) h.push({ text: "Referans No", value: "referenceNumber", sortable: false });
      h.push({ text: "Durum", value: "state", sortable: false });
      if (this.idiaColumnPrefs.mpStatus) h.push({ text: "Mp Durum", value: "status", sortable: false });
      if (this.idiaColumnPrefs.gibStatus) h.push({ text: "Gib Durum", value: "gibState", sortable: false });
      if (this.idiaColumnPrefs.discount) h.push({ text: "İndirim", value: "discountRate", sortable: false });
      if (this.showPaymentActionFilter) h.push({ text: "İşlem", value: "paymentAction", sortable: false });
      h.push({ text: "Okuma", value: "reading", sortable: false });
      if (this.showBlacklistColumn) h.push({ text: "Kara Liste", value: "blacklist", sortable: false });
      if (this.showCancelColumn) h.push({ text: "İptal", value: "cancelAction", sortable: false });
      if (this.isIdiaContext) h.push({ text: "Geçmiş Ödeme", value: "prevPay", sortable: false });
      if (Number(this.mpId) !== 5) h.push({ text: "Kayıp", value: "lostAction", sortable: false });
      return h;
    },
    tableHeaders() {
      let currentHeaders = this.headers;
      if (!this.showReferenceColumn) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "referenceNumber"
        );
      }
      if (!this.showPaymentActionFilter) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "paymentAction"
        );
      }
      if (!this.showCustomerNotes) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "customerNotes"
        );
      }
      if (!this.showPhoneEmail) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "phoneNumber" && header.value !== "email"
        );
      }
      if (!this.showBlacklistColumn) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "blacklist"
        );
      }
      if (!this.showPaymentMethodColumn) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "paymentMethodBadge"
        );
      }
      if (!this.showCancelColumn) {
        currentHeaders = currentHeaders.filter(
          (header) => header.value !== "cancelAction"
        );
      }
      return currentHeaders;
    },
    paymentActionOrderTotal() {
      if (!this.paymentActionOrder) {
        return 0;
      }
      return this.calculateOrderTotal(this.paymentActionOrder);
    },
    totalCurrentPrice() {
      return this.priceComparisonData.reduce((sum, item) => sum + (item.currentTotalPrice || 0), 0);
    },
    totalCurrentPriceFromDb() {
      return this.priceComparisonData.reduce((sum, item) => sum + (item.dbTotalPrice || 0), 0);
    },
    totalPriceDifference() {
      return this.totalCurrentPriceFromDb - this.totalCurrentPrice;
    },
  },

  created() {
    //this.initialize();
  },

  methods: {
    markLost(order) {
      const num = order.items && order.items[0] ? order.items[0].orderNumber : (order.packageNumber || '');
      if (order.isLost) {
        if (!window.confirm(num + ' numaralı siparişin kayıp işaretini kaldırmak istediğinize emin misiniz?')) return;
        this.applyLost(order.id, false);
        return;
      }
      this.lostConfirmOrder = { id: order.id, orderNumber: num };
      this.lostConfirmDialog = true;
    },
    async confirmMarkLost() {
      if (!this.lostConfirmOrder) return;
      this.lostConfirmLoading = true;
      await this.applyLost(this.lostConfirmOrder.id, true);
      this.lostConfirmLoading = false;
      this.lostConfirmDialog = false;
    },
    async applyLost(id, isLost) {
      try {
        const res = await this.$store.dispatch('orders/markOrderLost', { id, isLost });
        this.$store.state.dialog = true;
        this.$store.state.message = res && res.message ? res.message : 'İşlem tamamlandı.';
        await this.initialize();
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message = 'Kayıp işaretleme sırasında bir hata oluştu.';
      }
    },
    openInvoiceCancel(id, orderNumber) {
      this.invoiceCancelOrder = { id, orderNumber };
      this.invoiceCancelDialog = true;
    },
    async confirmInvoiceCancel() {
      if (!this.invoiceCancelOrder) return;
      this.invoiceCancelLoading = true;
      try {
        const res = await this.$store.dispatch("orders/cancelInvoice", this.invoiceCancelOrder.id);
        this.$store.state.dialog = true;
        this.$store.state.message = res && res.message ? res.message : "İşlem tamamlandı.";
        this.invoiceCancelDialog = false;
        await this.initialize();
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = (error.response && error.response.data && error.response.data.message) || "Fatura iptali sırasında bir hata oluştu.";
      } finally {
        this.invoiceCancelLoading = false;
      }
    },
    uploadFile() {
      debugger;
      this.files = this.$refs.file.files[0];
    },

    async pictureUploadEvent() {
      if (this.files) {
        const formData = new FormData();
        formData.append('file', this.files);
        this.insuranceItems = await this.$store.dispatch("orders/uploadInsurance", formData);
        this.insuranceDialog = true;
      }
    },

    async initialize() {
      this.$store.dispatch("orders/hbStatusGroup", {
        startDate: this.startDate,
        endDate: this.endDate,
      }).then(() => {
      });

      const selectedCities = Array.isArray(this.selectedCityFilters)
        ? this.selectedCityFilters.map(c => c.id).filter(c => c && c !== "")
        : (this.selectedCityFilters && this.selectedCityFilters.id && this.selectedCityFilters.id !== "-1"
            ? [this.selectedCityFilters.id]
            : []);

      await this.$store.dispatch("orders/searchOrder", {
        search: this.search,
        startDate: this.startDate,
        endDate: this.endDate,
        state: this.select.id,
        insuranceId: this.selectedInsuranceFilter.id,
        hbState: this.selectedHbStateFilters.id,
        cities: selectedCities,
        isComission: this.isNotMatchComission
      });
      this.orders = this.$store.state.orders.all;
      this.hasAverage = (await Api.get(
        `api/reports/getHasAverage?startDate=${this.getDate(
          0
        )}&endDate=${this.getDate(+1)}`
      )).data;
    },
    getDate(day) {
      return new Date()
        .addDays(day)
        .toISOString()
        .substr(0, 10);
    },
    editItem(item) {
      this.$router.push({ name: "order-detail", params: { id: item.id } });
    },

    deleteItem(item) {
      confirm("Silmek İstediğinizden Emin Misiniz?") &&
        this.$store.dispatch("orders/deleteOrder", item);
    },
    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.filteredOrders.slice();
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    shouldShowPaymentAction(orderItem, order) { // eslint-disable-line no-unused-vars
      if (!order) {
        return false;
      }
      return (
        Number(this.mpId) === 5 &&
          Number(order.state) === 5 &&
        order.paymentMethod !== undefined &&
        Number(order.paymentMethod) === 0
      );
    },
    async openPaymentActionModal(order) {
      this.paymentActionOrder = order;
      this.paymentActionDialog = true;
      await this.loadPriceComparisonData(order);
    },
    openCustomerNotesDialog(notes) {
      this.customerNotesContent = notes;
      this.customerNotesDialog = true;
    },
    closePaymentActionModal() {
      this.paymentActionDialog = false;
      this.paymentActionOrder = null;
      this.priceComparisonData = [];
      this.priceComparisonLoading = false;
    },
    handlePaymentReject() {
      this.confirmActionType = "reject";
      this.confirmCancelNote = "";
      this.actionConfirmDialog = true;
    },
    handlePaymentApprove() {
      this.confirmActionType = "approve";
      this.actionConfirmDialog = true;
    },
    closeConfirmDialog() {
      this.actionConfirmDialog = false;
      this.confirmActionType = null;
      this.confirmCancelNote = "";
      this.confirmActionLoading = false;
    },
    async confirmPaymentAction() {
      if (!this.confirmActionType) {
        return;
      }
      this.confirmActionLoading = true;
      const stateId = this.confirmActionType === "reject" ? 3 : 0;
      const extras =
          this.confirmActionType === "reject" && this.confirmCancelNote
              ? { canceledNote: this.confirmCancelNote }
              : {};
      try {
        await this.updatePaymentActionState(stateId, extras);
        this.closeConfirmDialog();
      } finally {
        this.confirmActionLoading = false;
      }
    },
    async updatePaymentActionState(stateId, extraPayload = {}) {
      if (!this.paymentActionOrder) {
        return;
      }
      try {
        await this.$store.dispatch("orders/bulkUpdateStates", {
          selectedItems: [this.paymentActionOrder],
          stateId,
          ...extraPayload,
        });
        this.$store.state.dialog = true;
        this.$store.state.message =
          stateId === 3 ? "Sipariş reddedildi." : "Sipariş onaylandı.";
        await this.initialize();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Payment action state update failed", error);
        this.$store.state.dialog = true;
        this.$store.state.message =
          "İşlem gerçekleştirilirken bir hata oluştu.";
      } finally {
        this.closePaymentActionModal();
      }
    },
    calculateOrderTotal(order) {
      if (!order || !order.items) {
        return 0;
      }
      return order.items.reduce((sum, item) => {
        const amount = item.totalPrice && item.totalPrice.amount ? item.totalPrice.amount : 0;
        return sum + amount;
      }, 0);
    },
    barcodePrint() {
      this.$store.commit("orders/setSelectedOrders", this.selected);
      sessionStorage.setItem("barcodeprint", JSON.stringify(this.selected));
      window.open("order/barcodeprint", "_blank");
    },
    barcodePrintOld() {
      this.$store.commit("orders/setSelectedOrders", this.selected);
      sessionStorage.setItem("barcodeprint", JSON.stringify(this.selected));
      window.open("order/barcodeprint-old", "_blank");
    },
    invoicePrint() {
      this.$store.commit("orders/setSelectedOrders", this.selected);
      sessionStorage.setItem("invoiceprint", JSON.stringify(this.selected));
      window.open("order/invoiceprint", "_blank");
    },
    async poolOrderAction() {
      let selectedOrder = [];
      this.selected.forEach((element) => {
        element.items.forEach((order) => {
          selectedOrder.push({
            id: element.id,
            indicator: element.indicator,
            orderDate: element.orderDate,
            identityNo: element.identityNo,
            shipmentNo: order.orderNumber,
            recipientName: element.recipientName,
            productName: order.productName,
            quantity: order.quantity,
            amount: order.merchantUnitPrice.amount,
            totalAmount: order.totalPrice.amount,
            barcode: element.barcode,
            iban: order.customizedText01
          });
        });
      });
      await this.$store.dispatch("poolOrders/postBulkPoolOrder", { Order: selectedOrder });
      await this.initialize();
      this.$store.state.dialog = true;
      this.$store.state.message = "İşleminiz Tamamlanmıştır.";
    },
    async popupInsurance() {
      this.insuranceDialog = true;
    },
    async saveInsurance() {

      this.selected.forEach(m => {
        m.poset = `${this.posetSeri}${this.posetNo}`;
        this.posetNo--;
      })

      this.insuranceDialog = false;
      await this.$store.dispatch("orders/saveInsurance", {
        selectedItems: this.selected,
        insuranceId: this.selectedInsurance.id
      });
      this.$store.state.dialog = true;
      this.$store.state.message = "İşleminiz Tamamlanmıştır.";

      return this.selected;
    },
    async saveAction() {
      if (this.selectedAction.value == "Kargo Gönderildi")
        this.poolOrderAction();
      else {
        await this.$store.dispatch("orders/bulkUpdateStates", {
          selectedItems: this.selected,
          stateId: this.selectedAction.id,
        });
        this.$store.state.dialog = true;
        this.$store.state.message = "İşleminiz Tamamlanmıştır.";
      }

      await this.initialize();
    },
    async reSendInvoice() {
      await this.$store.dispatch("orders/reSendInvoice", {
        selectedItems: this.selected,
        stateId: this.selectedAction.id,
        isInvoiceReSend: true,
      });
      this.$store.state.dialog = true;
      this.$store.state.message = "İşleminiz Tamamlanmıştır.";


      await this.initialize();
    },

    async sendReferenceNumber(order, _orderItem) { // eslint-disable-line no-unused-vars
      const referenceNumber = this.referenceNumbers[order.id];

      if (!referenceNumber || referenceNumber.trim() === '') {
        this.$store.state.dialog = true;
        this.$store.state.message = "Lütfen referans numarası giriniz.";
        return;
      }

      // eslint-disable-next-line no-console
      console.log('Reference number send button clicked for order:', order.id, 'with ref:', referenceNumber);

      this.$set(this.referenceLoadingStates, order.id, true);

      try {
        await Api.post(`/api/Idefix/SendReferenceNumberToIdefix?packageNumber=${order.packageNumber}&refNumber=${referenceNumber}`);

        // eslint-disable-next-line no-console
        console.log('Reference number sent successfully for order:', order.id);

        order.isReferenceNumberSend = true;
        this.$delete(this.referenceNumbers, order.id);

        this.$store.state.dialog = true;
        this.$store.state.message = "Referans numarası başarıyla gönderildi.";

      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error sending reference number:', error);

        this.$store.state.dialog = true;
        this.$store.state.message = "Referans numarası gönderilirken hata oluştu.";

      } finally {
        this.$set(this.referenceLoadingStates, order.id, false);
      }
    },
    async openReadingDialog(order) {
      if (!order) return;
      this.readingOrder = order;
      this.scannedBarcodes = [];
      this.claimBarcodes = [];
      this.readBarcodes = [];
      this.zimmetConfirmDialog = false;
      this.scanInput = "";
      this.acceptedCount = 0;
      this.readingErrorDialog = false;
      this.readingErrorText = "";
      this.readingNote = "";
      this.readingComplete = !!order.isReadingCompleted;
      this.readingLines = [];
      this.readingDialog = true;
      this.focusScan();
      // Backend'den SADECE takı kalemlerini + tamamlanma durumunu al
      try {
        const res = await inventoryApi.previewOrderReading(order.id, []);
        const data = (res && res.data) || {};
        if (Array.isArray(data.lines)) this.readingLines = data.lines;
        if (Array.isArray(data.readBarcodes)) this.readBarcodes = data.readBarcodes;
        this.readingComplete = !!data.isComplete;
        if (!this.readingLines.length) {
          this.readingNote = data.message || "Bu siparişte takı yok — okuma gerekmez.";
        }
      } catch (e) {
        /* yok say */
      }
    },
    closeReadingDialog() {
      // Toplu kalıcılık: onaylanmadan kapatılırsa okutmalar kaybolur → kayıp uyarısı
      const pending = this.scannedBarcodes && this.scannedBarcodes.length > 0;
      const alreadyDone = this.readingOrder && this.readingOrder.isReadingCompleted;
      if (pending && !alreadyDone) {
        if (!window.confirm("Okutmalar onaylanmadı. Kapatırsanız tüm okutmalar kaybolacak. Emin misiniz?")) {
          return;
        }
      }
      this.readingDialog = false;
      this.readingOrder = null;
      this.readingLines = [];
      this.scannedBarcodes = [];
      this.claimBarcodes = [];
      this.readBarcodes = [];
      this.zimmetConfirmDialog = false;
      this.scanInput = "";
      this.acceptedCount = 0;
      this.readingComplete = false;
    },
    focusScan() {
      this.$nextTick(() => {
        if (this.$refs.scanInput && this.$refs.scanInput.focus) this.$refs.scanInput.focus();
      });
    },
    showReadingError(code, reason) {
      this.readingErrorText = reason
        ? `${code} — ${reason}`
        : code
        ? `${code} — okutulamadı (siparişte yok / fazla / satılmış/rezerve).`
        : "Hatalı ürün.";
      this.readingErrorDialog = true;
    },
    dismissReadingError() {
      this.readingErrorDialog = false;
      this.focusScan();
    },
    // Preview yanıtındaki barkod-başı sonucu bulur (aynı barkod birden çoksa sonuncusu).
    findScan(data, code) {
      const scans = (data && data.scans) || [];
      for (let i = scans.length - 1; i >= 0; i--) if (scans[i].barcode === code) return scans[i];
      return null;
    },
    async onScan() {
      // Bazı barkod okuyucu/klavye düzenlerinde "-" karakteri "*" olarak geliyor; barkodlarımızda * yok → düzelt.
      const code = (this.scanInput || "").trim().replace(/\*/g, "-");
      this.scanInput = "";
      if (!code || this.readingLoading || !this.readingOrder) return;
      await this.scanCode(code);
    },
    async scanCode(code) {
      this.readingLoading = true;
      this.scannedBarcodes.push(code);
      try {
        const res = await inventoryApi.previewOrderReading(this.readingOrder.id, this.scannedBarcodes, this.claimBarcodes);
        const data = (res && res.data) || {};
        const scan = this.findScan(data, code);
        if (scan && scan.accepted) {
          this.acceptedCount = data.acceptedCount || this.acceptedCount;
          if (Array.isArray(data.lines)) this.readingLines = data.lines;
          if (Array.isArray(data.readBarcodes)) this.readBarcodes = data.readBarcodes;
          this.readingComplete = !!data.isComplete;
          this.focusScan();
        } else if (scan && scan.needsZimmetConfirm) {
          // Henüz kabul değil; operatör onayı alınacak.
          this.scannedBarcodes.pop();
          const who = scan.zimmetHolderName
            ? `«${scan.zimmetHolderName}» kullanıcısının zimmetinde`
            : "ana envanterde (zimmetli değil)";
          this.zimmetConfirmText = `${code} — bu takı ${who}. Senin zimmetine alınıp okutulsun mu?`;
          this.zimmetConfirmCode = code;
          this.zimmetConfirmDialog = true;
        } else {
          this.scannedBarcodes.pop();
          this.showReadingError(code, scan && scan.reason);
        }
      } catch (e) {
        this.scannedBarcodes.pop();
        this.showReadingError(code, null);
      } finally {
        this.readingLoading = false;
      }
    },
    async confirmZimmetClaim() {
      const code = this.zimmetConfirmCode;
      this.zimmetConfirmDialog = false;
      this.zimmetConfirmCode = "";
      if (!code) return;
      if (!this.claimBarcodes.includes(code)) this.claimBarcodes.push(code);
      await this.scanCode(code); // artık claim listesinde → kabul edilecek, zimmete alınacak
    },
    cancelZimmetClaim() {
      this.zimmetConfirmDialog = false;
      this.zimmetConfirmCode = "";
      this.focusScan();
    },
    // Bu oturumda yanlış okutulan bir barkodu listeden çıkar ve yeniden eşleştir.
    async removeScanned(code) {
      const idx = this.scannedBarcodes.indexOf(code);
      if (idx < 0) return;
      this.scannedBarcodes.splice(idx, 1);
      const ci = this.claimBarcodes.indexOf(code);
      if (ci >= 0) this.claimBarcodes.splice(ci, 1);
      this.readingLoading = true;
      try {
        const res = await inventoryApi.previewOrderReading(this.readingOrder.id, this.scannedBarcodes, this.claimBarcodes);
        const data = (res && res.data) || {};
        this.acceptedCount = data.acceptedCount || 0;
        if (Array.isArray(data.lines)) this.readingLines = data.lines;
        this.readingComplete = !!data.isComplete;
      } catch (e) {
        /* yok say */
      } finally {
        this.readingLoading = false;
        this.focusScan();
      }
    },
    async confirmReading() {
      if (!this.readingOrder || !this.readingComplete) return;
      this.readingConfirmLoading = true;
      try {
        const res = await inventoryApi.confirmOrderReading(this.readingOrder.id, this.scannedBarcodes, this.claimBarcodes);
        const data = (res && res.data) || {};
        if (data.success) {
          this.$set(this.readingOrder, "isReadingCompleted", true);
          this.$store.state.dialog = true;
          this.$store.state.message = "Okuma tamamlandı.";
          this.closeReadingDialog();
        } else {
          this.$store.state.dialog = true;
          this.$store.state.message = data.message || "Okuma tamamlanamadı.";
        }
      } catch (e) {
        this.$store.state.dialog = true;
        this.$store.state.message =
          "Okuma onayında hata: " + ((e.response && e.response.data && e.response.data.message) || e.message);
      } finally {
        this.readingConfirmLoading = false;
      }
    },
    async loadPriceComparisonData(order) {
      this.priceComparisonData = [];
      this.priceComparisonLoading = true;

      try {
        if (!order || !order.items || !order.items.length) {
          return;
        }

        const useTransferPrice = Number(order.paymentMethod) === 0;
        const useInstallmentPrice = Number(order.paymentMethod) === 4;

        const orderItems = order.items.map((item) => ({
          productId: item.productId,
          productName: item.productName,
          quantity: item.quantity,
          currentTotalPrice: item.totalPrice && item.totalPrice.amount ? Number(item.totalPrice.amount) : 0,
          currentUnitPrice:
            item.totalPrice && item.totalPrice.amount && item.quantity
              ? Number(item.totalPrice.amount) / Number(item.quantity)
              : 0,
        })).filter(item => item.productId);

        const uniqueProductIds = [...new Set(orderItems.map(item => item.productId))];

        const productPriceMap = {};
        await Promise.all(
          uniqueProductIds.map(async (productId) => {
            let resolvedPrice = 0;
            try {
              const mpProductResponse = await mpProductsApi.getMpProductByProduct(productId);
              if (mpProductResponse && mpProductResponse.data) {
                const mpProduct = mpProductResponse.data;
                if (useTransferPrice) {
                  resolvedPrice = Number(mpProduct.transferPrice || mpProduct.price || mpProduct.listPrice || 0);
                } else if (useInstallmentPrice) {
                  resolvedPrice = Number(mpProduct.priceWithInstallment || mpProduct.price || mpProduct.listPrice || 0);
                } else {
                  resolvedPrice = Number(mpProduct.price || mpProduct.transferPrice || mpProduct.listPrice || 0);
                }
              }
            } catch (error) {
              // eslint-disable-next-line no-console
              console.error(`MpProduct ${productId} fiyatı alınamadı:`, error);
            }

            if (!resolvedPrice) {
              try {
                const productResponse = await productsApi.getProduct(productId);
                if (productResponse && productResponse.data) {
                  const product = productResponse.data;
                  resolvedPrice = Number(
                    (useTransferPrice && product.transferPrice) ||
                    (useInstallmentPrice && product.priceWithInstallment) ||
                    product.price ||
                    product.listPrice ||
                    product.purchasePrice ||
                    0
                  );
                }
              } catch (fallbackError) {
                // eslint-disable-next-line no-console
                console.error(`Product ${productId} fiyatı alınamadı:`, fallbackError);
              }
            }

            productPriceMap[productId] = resolvedPrice;
          })
        );

        this.priceComparisonData = orderItems.map((item) => {
          const dbUnitPrice = productPriceMap[item.productId] || 0;
          const dbTotalPrice = dbUnitPrice * Number(item.quantity);
          const difference = dbTotalPrice - item.currentTotalPrice;

          return {
            productName: item.productName,
            quantity: item.quantity,
            currentUnitPrice: item.currentUnitPrice,
            currentTotalPrice: item.currentTotalPrice,
            dbUnitPrice,
            dbTotalPrice,
            difference,
          };
        });
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Fiyat karşılaştırması hatası:", error);
        this.$store.state.dialog = true;
        this.$store.state.message = "Fiyat karşılaştırması yapılırken bir hata oluştu.";
      } finally {
        this.priceComparisonLoading = false;
      }
    },

    async openFraudModal() {
      this.fraudDialog = true;
      this.fraudLoading = true;
      this.fraudEmailPrepared = false;
      this.fraudOrders = [];
      try {
        const response = await ordersApi.getFraudOrders();
        this.fraudOrders = response.data || [];
      } catch (error) {
        this.$store.state.dialog = true;
        this.$store.state.message = "Fraud siparişleri yüklenirken bir hata oluştu.";
        // eslint-disable-next-line no-console
        console.error("Error loading fraud orders:", error);
      } finally {
        this.fraudLoading = false;
      }
    },

    closeFraudModal() {
      this.fraudDialog = false;
      this.fraudOrders = [];
      this.fraudLoading = false;
      this.fraudEmailPrepared = false;
    },

    prepareFraudEmail() {
      if (!this.fraudOrders || this.fraudOrders.length === 0) return;

      const orderNumbers = this.fraudOrders.map(fo => fo.orderNumber).join('\n');
      const subject = "Kontrol edilecek siparişler";
      const body = `Merhaba,\n\nAşağıdaki sipariş numaralarının kontrol edilmesi gerekmektedir:\n\n${orderNumbers}\n\nTeşekkürler.`;
      const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      window.location.href = mailtoLink;

      this.fraudEmailPrepared = true;
    },

    async markFraudAsSent() {
      try {
        const orderNumbers = this.fraudOrders.map(fo => fo.orderNumber);
        await ordersApi.markFraudSent(orderNumbers);

        this.$store.state.dialog = true;
        this.$store.state.message = "Siparişler fraud olarak işaretlendi.";

        this.closeFraudModal();
        await this.initialize();
      } catch (error) {
        this.$store.state.dialog = true;
        const errorMessage = (error.response && error.response.data && error.response.data.message)
          ? error.response.data.message
          : "Siparişler işaretlenirken bir hata oluştu.";
        this.$store.state.message = errorMessage;
        // eslint-disable-next-line no-console
        console.error("Error marking orders as sent for fraud:", error);
      }
    },
    isBlackListedEmail(email) {
      if (!email) return false;
      return this.blacklistedEmailsSet.has(email.trim().toLowerCase());
    },
    paymentMethodLabel(pm) {
      const n = Number(pm);
      if (n === 0) return 'Havale / EFT';
      if (n === 1) return 'Kredi Kartı';
      if (n === 4) return 'Taksitli Kredi Kartı';
      return '—';
    },
    paymentMethodColor(pm) {
      const n = Number(pm);
      if (n === 0) return 'blue lighten-4';
      if (n === 1) return 'green lighten-4';
      if (n === 4) return 'purple lighten-4';
      return 'grey lighten-3';
    },
    paymentMethodTextColor(pm) {
      const n = Number(pm);
      if (n === 0) return 'blue darken-2';
      if (n === 1) return 'green darken-2';
      if (n === 4) return 'purple darken-2';
      return 'grey darken-2';
    },
    paymentMethodIcon(pm) {
      const n = Number(pm);
      if (n === 0) return 'account_balance';
      if (n === 1) return 'credit_card';
      if (n === 4) return 'event_repeat';
      return 'help_outline';
    },
    canCancelOrder(item) {
      if (!item) return false;
      if (Number(item.paymentMethod) === 0) return false;
      const state = Number(item.state);
      if (state === 2 || state === 3 || state === 4 || state === 6) return false;
      return true;
    },
    cancelButtonTitle(item) {
      if (!item) return '';
      if (Number(item.paymentMethod) === 0) return 'Havale/EFT ödemesi Paycell üzerinden iptal/iade edilemez';
      const state = Number(item.state);
      if (state === 3) return 'Bu sipariş zaten iptal edildi';
      if (state === 4) return 'Bu sipariş zaten iade edildi';
      if (state === 2) return 'Sipariş kargoya verildi, iptal edilemez';
      if (state === 6) return 'Sipariş teslim edildi, iptal edilemez';
      return 'Siparişi iptal et (Idia + Paycell)';
    },
    openCancelOrderModal(item) {
      if (!this.canCancelOrder(item)) return;
      this.cancelOrderDialog = {
        open: true,
        step: 1,
        order: {
          id: item.id,
          orderNumber: (item.items && item.items[0] && item.items[0].orderNumber) || '',
          packageNumber: item.packageNumber || '',
        },
        packageInput: '',
        note: '',
        error: '',
        busy: false,
        lastResult: null,
        idiaRetryFailed: false,
      };
    },
    closeCancelOrderDialog() {
      if (this.cancelOrderDialog.busy) return;
      this.cancelOrderDialog.open = false;
    },
    async openPreviousPayments(orderNumber) {
      this.prevPayOrderNo = orderNumber || '';
      this.prevPayments = [];
      this.prevPayError = '';
      this.prevPayDialog = true;
      this.prevPayLoading = true;
      try {
        const { data } = await ordersApi.getPreviousPayments(orderNumber);
        this.prevPayments = (data && data.data && data.data.previousPayments) || [];
        if ((!data || !data.success) && (!this.prevPayments || this.prevPayments.length === 0)) {
          this.prevPayError = (data && data.message) || 'Geçmiş ödeme bulunamadı.';
        }
      } catch (e) {
        this.prevPayError = (e && e.response && e.response.data && e.response.data.message) || 'Geçmiş ödemeler alınamadı.';
      } finally {
        this.prevPayLoading = false;
      }
    },
    formatPrevPayAmount(amount, currency) {
      const n = Number(amount) || 0;
      const s = n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      return currency ? `${s} ${currency}` : s;
    },
    formatPrevPayDate(value) {
      if (!value) return '';
      const d = new Date(value);
      if (isNaN(d.getTime())) return value;
      return d.toLocaleDateString('tr-TR') + ' ' + d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
    },
    async copyCancelPackageNumber() {
      const pkg = this.cancelOrderDialog.order && this.cancelOrderDialog.order.packageNumber;
      if (!pkg) return;
      try {
        await navigator.clipboard.writeText(pkg);
      } catch (e) {
        const ta = document.createElement('textarea');
        ta.value = pkg;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        try { document.execCommand('copy'); } catch (err) { /* ignore */ }
        document.body.removeChild(ta);
      }
    },
    validateCancelPackageNumber() {
      const expected = (this.cancelOrderDialog.order.packageNumber || '').trim();
      const given = (this.cancelOrderDialog.packageInput || '').trim();
      if (!given) {
        this.cancelOrderDialog.error = 'Paket numarası giriniz.';
        return;
      }
      if (!expected || given !== expected) {
        this.cancelOrderDialog.error = 'Paket numarası eşleşmiyor.';
        return;
      }
      this.cancelOrderDialog.error = '';
      this.cancelOrderDialog.step = 2;
    },
    async confirmOrderCancel() {
      const orderId = this.cancelOrderDialog.order.id;
      const pkg = (this.cancelOrderDialog.order.packageNumber || '').trim();
      const note = (this.cancelOrderDialog.note || '').trim() || null;
      this.cancelOrderDialog.busy = true;
      try {
        const resp = await ordersApi.cancelForIdia(orderId, pkg, note);
        this.cancelOrderDialog.lastResult = resp.data;
        this.cancelOrderDialog.idiaRetryFailed = false;
        this.cancelOrderDialog.step = 3;
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message)
          || 'Sipariş iptal edilirken bir hata oluştu.';
        this.cancelOrderDialog.error = msg;
        this.cancelOrderDialog.step = 1;
        this.$store.state.dialog = true;
        this.$store.state.message = `✗ ${msg}`;
      } finally {
        this.cancelOrderDialog.busy = false;
      }
    },
    async retryOrderIdiaCancel() {
      const orderId = this.cancelOrderDialog.order.id;
      const note = (this.cancelOrderDialog.note || '').trim() || null;
      this.cancelOrderDialog.busy = true;
      try {
        const resp = await ordersApi.retryIdiaCancelNotification(orderId, note);
        this.cancelOrderDialog.lastResult = Object.assign(
          {},
          this.cancelOrderDialog.lastResult || {},
          {
            localSuccess: resp.data.localSuccess,
            idiaSuccess: resp.data.idiaSuccess,
            message: resp.data.message,
          }
        );
        this.cancelOrderDialog.idiaRetryFailed = !(resp.data && resp.data.idiaSuccess);
      } catch (error) {
        this.cancelOrderDialog.idiaRetryFailed = true;
        this.cancelOrderDialog.lastResult = Object.assign(
          {},
          this.cancelOrderDialog.lastResult || { localSuccess: true, orderNumber: this.cancelOrderDialog.order.orderNumber },
          { idiaSuccess: false }
        );
      } finally {
        this.cancelOrderDialog.busy = false;
      }
    },
    async finishCancelOrderDialog() {
      this.cancelOrderDialog.open = false;
      await this.initialize();
    },
    async loadBlacklistedEmails() {
      try {
        const r = await ordersApi.getBlacklistedCustomers();
        const list = (r && r.data) || [];
        const next = new Set();
        list.forEach((b) => {
          if (b && b.email) next.add(String(b.email).trim().toLowerCase());
        });
        this.blacklistedEmailsSet = next;
      } catch (e) {
        // sessiz — kara liste yüklenemese de sayfanın geri kalanı çalışsın
        // eslint-disable-next-line no-console
        console.error('Blacklist yüklenemedi:', e);
      }
    },
    openBlacklistConfirm(item) {
      if (!item || !item.email) return;
      this.blacklistConfirmItem = item;
      this.blacklistConfirmDialog = true;
    },
    cancelBlacklistAction() {
      this.blacklistConfirmDialog = false;
      this.blacklistConfirmItem = null;
    },
    async confirmBlacklistAction() {
      const item = this.blacklistConfirmItem;
      if (!item || !item.email) {
        this.blacklistConfirmDialog = false;
        return;
      }
      const email = item.email.trim().toLowerCase();
      const isCurrentlyListed = this.blacklistedEmailsSet.has(email);
      this.blacklistConfirmLoading = true;
      try {
        if (isCurrentlyListed) {
          await ordersApi.removeCustomerFromBlacklist(item.email);
          const next = new Set(this.blacklistedEmailsSet);
          next.delete(email);
          this.blacklistedEmailsSet = next;
        } else {
          await ordersApi.addCustomerToBlacklist(item.email);
          const next = new Set(this.blacklistedEmailsSet);
          next.add(email);
          this.blacklistedEmailsSet = next;
        }
        this.blacklistConfirmDialog = false;
        this.blacklistConfirmItem = null;
      } catch (err) {
        const msg = (err && err.response && err.response.data && err.response.data.message)
          ? err.response.data.message
          : 'Kara liste işlemi başarısız oldu.';
        this.$store.state.dialog = true;
        this.$store.state.message = msg;
      } finally {
        this.blacklistConfirmLoading = false;
      }
    },
    persistIdiaColumnPrefs() {
      try {
        localStorage.setItem('idiaOrderColumnPrefs', JSON.stringify(this.idiaColumnPrefs));
      } catch (e) { /* ignore */ }
    },
    loadIdiaColumnPrefs() {
      try {
        const raw = localStorage.getItem('idiaOrderColumnPrefs');
        if (!raw) return;
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          this.idiaColumnPrefs = {
            mpStatus: !!parsed.mpStatus,
            gibStatus: !!parsed.gibStatus,
            discount: !!parsed.discount,
          };
        }
      } catch (e) { /* ignore */ }
    },
    toggleIdiaColumn(key) {
      this.idiaColumnPrefs[key] = !this.idiaColumnPrefs[key];
      this.persistIdiaColumnPrefs();
    },
    parsePaycellInfo(raw) {
      if (!raw) return null;
      let obj = raw;
      if (typeof raw === 'string') {
        try { obj = JSON.parse(raw); } catch (e) { return null; }
      }
      if (!obj || typeof obj !== 'object') return null;
      const data = obj.data || obj.Data || obj;
      if (!data || typeof data !== 'object') return null;
      const payments = data.payments || data.Payments || [];
      return { payments: Array.isArray(payments) ? payments : [] };
    },
    readPaycellField(payment, field) {
      if (!payment || typeof payment !== 'object') return null;
      if (payment[field] !== undefined && payment[field] !== null) return payment[field];
      const lower = field.charAt(0).toLowerCase() + field.slice(1);
      if (payment[lower] !== undefined && payment[lower] !== null) return payment[lower];
      return null;
    },
    isPaycellCompleted(payment) {
      const status = this.readPaycellField(payment, 'PaymentStatus');
      return typeof status === 'string' && status.trim().toUpperCase() === 'COMPLETED';
    },
    getFirstPaycellPayment(order) {
      const parsed = this.parsePaycellInfo(order && order.payCellInfo);
      if (!parsed || !parsed.payments || parsed.payments.length === 0) return null;
      return parsed.payments[0];
    },
    paycellPaymentCount(order) {
      const parsed = this.parsePaycellInfo(order && order.payCellInfo);
      return parsed && parsed.payments ? parsed.payments.length : 0;
    },
    formatPaycellAmount(amt) {
      if (amt === null || amt === undefined || amt === '') return '-';
      const n = Number(amt);
      if (isNaN(n)) return amt;
      return n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    },
    formatPaycellDate(dt) {
      if (!dt) return '-';
      const d = new Date(dt);
      if (isNaN(d.getTime())) return dt;
      return d.toLocaleString('tr-TR');
    },
  },
  async mounted() {
    this.$store.dispatch("orders/getCity", {}).then(() => {
    });

    // await this.$store.dispatch("insurances/getAllInsurances");
    // this.selectedInsurance = this.$store.state.insurances.insurances;
    const selectedTenant = localStorage.getItem('selectedTenantId');
    const selectedMp = localStorage.getItem('selectedMpId');
    const currentUser = authenticationService.currentUserValue;

    this.tenantId = selectedTenant || (currentUser && currentUser.tenantId) || localStorage.getItem("tenantId");
    this.mpId = selectedMp || (currentUser && currentUser.mpId);

    // eslint-disable-next-line no-console
    console.log('Current tenantId:', this.tenantId);
    // eslint-disable-next-line no-console
    console.log('Current mpId:', this.mpId);

    if (this.tenantId == 1)
      this.headers = this.headers.filter((m) => m.value != "customizedText01");

    this.loadIdiaColumnPrefs();

    await this.initialize();

    if (this.showBlacklistColumn) {
      await this.loadBlacklistedEmails();
    }
  }
};
</script>
<style>
.redd {
  color: red;
}

/* Sipariş tablosu — kolon hizalama ve genişlik düzenlemeleri */
.v-datatable__actions {
  flex-wrap: wrap;
}

.v-datatable th,
.v-datatable td {
  white-space: nowrap;
  vertical-align: middle !important;
}

.v-datatable th {
  font-weight: 600;
  font-size: 13px;
  padding: 8px 10px !important;
  background: #fafafa;
  border-bottom: 2px solid #e0e0e0;
}

.v-datatable td {
  padding: 8px 10px !important;
  font-size: 14px;
}

/* Buton kolonları için minimum genişlik */
.v-datatable td:has(.v-btn) {
  min-width: 110px;
}

/* Tablonun horizontal scroll ile düzgün taşımasını sağla */
.v-datatable {
  overflow-x: auto;
}

/* İdia AltındaFırsat gruplu sipariş tablosu */
.idia-column-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 10px 4px;
  flex-wrap: wrap;
}
.idia-column-toolbar-label {
  font-size: 13px;
  font-weight: 600;
  color: #4b5563;
  margin-right: 6px;
}
.idia-order-table td {
  vertical-align: middle !important;
}
.idia-order-table .v-btn {
  margin: 0 auto;
}
.idia-group {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 140px;
}
.idia-g-main {
  font-weight: 600;
  color: #1e293b;
  font-size: 14px;
}
.idia-g-sub {
  font-size: 12.5px;
  color: #64748b;
}
.idia-g-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 12px;
  word-break: break-all;
}
.idia-dup {
  background: #dc2626;
  color: #fff;
  font-size: 11px;
  padding: 1px 6px;
  border-radius: 4px;
  width: fit-content;
}
.idia-paycell-ok {
  color: #16a34a;
  font-weight: 700;
}
.idia-paycell-fail {
  color: #dc2626;
  font-weight: 700;
}

.order-tabs .v-tabs__bar {
  background: linear-gradient(135deg, #1d4ed8, #2563eb) !important;
}
.order-tabs .v-tabs__item {
  color: #ffffff !important;
  opacity: 0.78;
  font-weight: 800;
  letter-spacing: 0.2px;
  text-transform: none;
}
.order-tabs .v-tabs__item--active {
  opacity: 1;
  font-weight: 900;
  background: rgba(255, 255, 255, 0.14);
  border-radius: 10px;
}
.order-tabs .v-tabs__slider {
  background-color: #ffffff !important;
  height: 4px !important;
}
</style>
